<template>
  <div>
    <section class="content-header">
      <h1>
        <span>{{ $ml.get('shared.reports') }}</span>
      </h1>
      <ol class="breadcrumb">
        <li>
          <i class="fa fa-dashboard"></i>
          <span>{{ $ml.get('shared.dashboard') }}</span>
        </li>
        <li>
          <span>{{ $ml.get('shared.reports') }}</span>
        </li>
      </ol>
    </section>
    <section class="content">
      <div class="row">
        <div class="col-sm-12">
          <div class="nav-tabs-custom">
            <ul class="nav nav-tabs">
              <li :class="activeScreen == 1 ? 'active' : ''">
                <a @click="activeScreen = 1" style="cursor:pointer;">
                  <i class="fa fa-filter"></i> {{ $ml.get('filters.filterEmployees') }}
                </a>
              </li>
              <li :class="activeScreen == 2 ? 'active' : ''">
                <a @click="activeScreen = 2" style="cursor:pointer;">
                  <i class="fa fa-cogs"></i> {{ $ml.get('reports.selectReport') }}
                </a>
              </li>
              <li :class="activeScreen == 3 ? 'active' : ''">
                <a @click="activeScreen = 3" style="cursor:pointer;">
                  <i class="fa fa-file-text"></i> {{ $ml.get('reports.report') }}
                </a>
              </li>
            </ul>
            <div class="tab-content">
              <div v-show="activeScreen == 1" :class="activeScreen == 1 ? 'row tab-pane active' : 'row tab-pane'"
                style="margin-top: 10px;"><!-- KİŞİ FİLTRE -->
                <div class="col-sm-8">
                  <div class="box box-danger">
                    <div class="box-header">
                      <h3 class="box-title" align="center">{{ $ml.get('filters.filterEmployees') }}</h3>
                    </div>
                    <div class="box-body">
                      <div class="row">
                        <div class="col-sm-6">
                          <div class="form-group">
                            <span>{{ $ml.get('filters.filterNameSurnameOrCardNo') }}</span>
                            <input v-model="filters.nameOrCardNumber" type="text" class="form-control input-sm"
                              :placeholder="$ml.get('filters.filterNameSurnameOrCardNo')" style="margin-bottom:5px;" />
                          </div>
                          <div class="form-group">
                            <span>{{ $ml.get('filters.filterCitizenshipNumber') }}</span>
                            <input v-model="filters.identityNo" type="text" class="form-control input-sm"
                              :placeholder="$ml.get('filters.filterCitizenshipNumber')" style="margin-bottom:5px;" />
                          </div>
                          <div class="form-group">
                            <span>{{ $ml.get('filters.filterRegistrationOrDeviceNo') }}</span>
                            <input v-model="filters.sicilOrTerminalNo" type="text" class="form-control input-sm"
                              :placeholder="$ml.get('filters.filterRegistrationOrDeviceNo')"
                              style="margin-bottom:5px;" />
                          </div>
                          <div class="form-group">
                            <span>{{ $ml.get('filters.filterDocumentNoOrEmail') }}</span>
                            <input v-model="filters.documentNoOrMail" type="text" class="form-control input-sm"
                              :placeholder="$ml.get('filters.filterDocumentNoOrEmail')" style="margin-bottom:5px;" />
                          </div>
                          <div class="form-group" v-show="modules.licencePlateRecognition">
                            <span>{{ $ml.get('filters.filterPlateNo') }}</span>
                            <input v-model="filters.plateNo" type="text" class="form-control input-sm"
                              :placeholder="$ml.get('filters.filterPlateNo')" style="margin-bottom:5px;" />
                          </div>
                          <div class="form-group">
                            <span>{{ $ml.get('filters.filterTitle') }}</span>
                            <select @change="changeFilterTitles($event)" class="form-control input-sm"
                              style="margin-bottom:5px;">
                              <option :selected="filters.title == ''" value>{{ $ml.get('general.select') }}</option>
                              <option v-for="(title, index) in titleList" :key="'title' + index" :value="title.name"
                                :selected="title.name == filters.title">{{ title.name }}</option>
                            </select>
                          </div>
                          <div class="form-group">
                            <span>{{ $ml.get('filters.filterDeleted') }}</span>
                            <span class="form-control checkbox">
                              <label style="margin-left:20px;">
                                <input :checked="filters.isActive"
                                  @change="filters.isActive == true ? filters.isActive = false : filters.isActive = true"
                                  type="checkbox" />
                                {{ $ml.get('filters.filterNotShow') }}
                              </label>
                            </span>
                          </div>
                          <div class="form-group" v-show="modules.visitor">
                            <span>{{ $ml.get('filters.filterVisitorCards') }}</span>
                            <span class="form-control checkbox">
                              <label style="margin-left:20px;">
                                <input :checked="filters.isVisitor"
                                  @change="filters.isVisitor == true ? filters.isVisitor = false : filters.isVisitor = true"
                                  type="checkbox" />
                                {{ $ml.get('filters.filterShow') }}
                              </label>
                            </span>
                          </div>
                        </div>
                        <div class="col-sm-6">
                          <div class="form-group">
                            <label>{{ $ml.get('filters.filterStatus') }}</label>
                            <div class="input-group">
                              <label v-show="checkedStatusList != ''" class="form-control tdb-box">{{ checkedStatusList
                                }}</label>
                              <label v-show="checkedStatusList == ''" class="form-control">{{
                                $ml.get('general.notSelected')
                                }}</label>
                              <div class="input-group-btn">
                                <button class="btn btn-default" data-toggle="modal" data-target="#modal-select-status">
                                  <i class="fa fa-search"></i>
                                </button>
                                <button v-show="checkedStatusList != ''" class="btn btn-danger"
                                  @click="clearFilterStatus()">
                                  <i class="fa fa-remove"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                          <div class="form-group">
                            <label>{{ $ml.get('filters.filterDepartments') }}</label>
                            <div class="input-group">
                              <label v-show="checkedDepartmentList != ''" class="form-control tdb-box">{{
                                checkedDepartmentList
                                }}</label>
                              <label v-show="checkedDepartmentList == ''" class="form-control">{{
                                $ml.get('general.notSelected')
                                }}</label>
                              <div class="input-group-btn">
                                <button class="btn btn-default" data-toggle="modal"
                                  data-target="#modal-select-department">
                                  <i class="fa fa-search"></i>
                                </button>
                                <button v-show="checkedDepartmentList != ''" class="btn btn-danger"
                                  @click="clearFilterDepartments()">
                                  <i class="fa fa-remove"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                          <div class="form-group">
                            <label>{{ $ml.get('filters.filterAccessGroup') }}</label>
                            <div class="input-group">
                              <label v-show="checkedAccessGroupList != ''" class="form-control tdb-box">{{
                                checkedAccessGroupList
                                }}</label>
                              <label v-show="checkedAccessGroupList == ''" class="form-control">{{
                                $ml.get('general.notSelected')
                                }}</label>
                              <div class="input-group-btn">
                                <button class="btn btn-default" data-toggle="modal" data-target="#modal-select-access">
                                  <i class="fa fa-search"></i>
                                </button>
                                <button v-show="checkedAccessGroupList != ''" class="btn btn-danger"
                                  @click="clearFilterAccessGroup()">
                                  <i class="fa fa-remove"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                          <div class="form-group">
                            <label>{{ $ml.get('filters.filterWorkPlan') }}</label>
                            <div class="input-group">
                              <label v-show="checkedWorkGroupList != ''" class="form-control tdb-box">{{
                                checkedWorkGroupList
                                }}</label>
                              <label v-show="checkedWorkGroupList == ''" class="form-control">{{
                                $ml.get('general.notSelected')
                                }}</label>
                              <div class="input-group-btn">
                                <button class="btn btn-default" data-toggle="modal"
                                  data-target="#modal-select-workplan">
                                  <i class="fa fa-search"></i>
                                </button>
                                <button v-show="checkedWorkGroupList != ''" class="btn btn-danger"
                                  @click="clearFilterWorkPlans()">
                                  <i class="fa fa-remove"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                          <div class="form-group" v-show="modules.diningHall">
                            <label>{{ $ml.get('filters.filterFoodGroup') }}</label>
                            <div class="input-group">
                              <label v-show="checkedFoodGroupList != ''" class="form-control tdb-box">{{
                                checkedFoodGroupList
                                }}</label>
                              <label v-show="checkedFoodGroupList == ''" class="form-control">{{
                                $ml.get('general.notSelected')
                                }}</label>
                              <div class="input-group-btn">
                                <button class="btn btn-default" data-toggle="modal"
                                  data-target="#modal-select-diningHall">
                                  <i class="fa fa-search"></i>
                                </button>
                                <button v-show="checkedFoodGroupList != ''" class="btn btn-danger"
                                  @click="clearFilterFoodGroups()">
                                  <i class="fa fa-remove"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                          <div class="form-group">
                            <label>{{ $ml.get('filters.filterState') }}</label>
                            <div class="input-group">
                              <label v-show="checkedStateList != ''" class="form-control tdb-box">{{ checkedStateList
                                }}</label>
                              <label v-show="checkedStateList == ''" class="form-control">{{
                                $ml.get('general.notSelected')
                                }}</label>
                              <div class="input-group-btn">
                                <button class="btn btn-default" data-toggle="modal" data-target="#modal-select-state">
                                  <i class="fa fa-search"></i>
                                </button>
                                <button v-show="checkedStateList != ''" class="btn btn-danger"
                                  @click="clearFilterStates()">
                                  <i class="fa fa-remove"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="callout callout-info" style="margin-top:10px;">
                        <div class="row">
                          <div class="col-sm-3">
                            <select @change="changeFilterExtraField1($event)" class="form-control input-sm text-center"
                              style="margin-bottom:5px; text-align:center;">
                              <option :selected="filters.extraField1key == 0" value>{{
                                $ml.get('filters.filterSelectExtraFields')
                                }}
                              </option>
                              <option v-for="extraField in extraFieldList" :key="'extraField1-' + extraField.id"
                                :value="extraField.id" :selected="extraField.id == filters.extraField1key">{{
                                  extraField.name }}
                              </option>
                            </select>
                          </div>
                          <div class="col-sm-3">
                            <input v-model="filters.extraField1value" type="text" class="form-control input-sm"
                              :placeholder="$ml.get('filters.filterValue')" style="margin-bottom:5px;" />
                          </div>
                          <div class="col-sm-3">
                            <select @change="changeFilterExtraField2($event)" class="form-control input-sm text-center"
                              style="margin-bottom:5px; text-align:center;">
                              <option :selected="filters.extraField2key == 0" value>{{
                                $ml.get('filters.filterSelectExtraFields')
                                }}
                              </option>
                              <option v-for="extraField in extraFieldList" :key="'extraField2-' + extraField.id"
                                :value="extraField.id" :selected="extraField.id == filters.extraField2key">{{
                                  extraField.name }}
                              </option>
                            </select>
                          </div>
                          <div class="col-sm-3">
                            <input v-model="filters.extraField2value" type="text" class="form-control input-sm"
                              :placeholder="$ml.get('filters.filterValue')" style="margin-bottom:5px;" />
                          </div>
                          <div class="col-sm-3">
                            <select @change="changeFilterExtraField3($event)" class="form-control input-sm text-center"
                              style="margin-bottom:5px; text-align:center;">
                              <option :selected="filters.extraField3key == 0" value>{{
                                $ml.get('filters.filterSelectExtraFields')
                                }}
                              </option>
                              <option v-for="extraField in extraFieldList" :key="'extraField3-' + extraField.id"
                                :value="extraField.id" :selected="extraField.id == filters.extraField3key">{{
                                  extraField.name }}
                              </option>
                            </select>
                          </div>
                          <div class="col-sm-3">
                            <input v-model="filters.extraField3value" type="text" class="form-control input-sm"
                              :placeholder="$ml.get('filters.filterValue')" style="margin-bottom:5px;" />
                          </div>
                          <div class="col-sm-3">
                            <select @change="changeFilterExtraField4($event)" class="form-control input-sm text-center"
                              style="margin-bottom:5px; text-align:center;">
                              <option :selected="filters.extraField4key == 0" value>{{
                                $ml.get('filters.filterSelectExtraFields')
                                }}
                              </option>
                              <option v-for="extraField in extraFieldList" :key="'extraField4-' + extraField.id"
                                :value="extraField.id" :selected="extraField.id == filters.extraField4key">{{
                                  extraField.name }}
                              </option>
                            </select>
                          </div>
                          <div class="col-sm-3">
                            <input v-model="filters.extraField4value" type="text" class="form-control input-sm"
                              :placeholder="$ml.get('filters.filterValue')" style="margin-bottom:5px;" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="box-footer text-right">
                      <button @click="filtersClear()" class="btn btn-warning">
                        <i class="fa fa-trash-o"></i>
                        <span>{{ $ml.get('filters.filterClear') }}</span>
                      </button>
                      <button @click="getEmployees()" class="btn btn-success">
                        <i class="fa fa-search"></i>
                        <span>{{ $ml.get('filters.filterApply') }}</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="box box-primary">
                    <div class="box-header">
                      <h4 class="box-title" style="display: flex; justify-content: space-between; align-items: center;">
                        <span>Seçilen Kişiler</span>
                        <a @click="checkEmployees()" style="cursor:pointer;font-size:15px;">
                          <span v-show="!isCheck">{{ $ml.get('general.selectAll') }}</span>
                          <span v-show="isCheck">{{ $ml.get('general.removeAll') }}</span>
                        </a>
                      </h4>
                      <div class="form-group" style="margin-top: 10px;">
                        <input v-model="searchText" class="form-control"
                          :placeholder="$ml.get('filters.searchEmployeeFromList')" />
                      </div>
                    </div>
                    <div class="box-body">
                      <div v-show="employeeFilteredList.length > 0" class="table-responsive no-padding"
                        :style="windowHeightTableSize">
                        <table class="table table-hover">
                          <thead>
                            <tr>
                              <td></td>
                              <td @click="setOrderEmp(1)" style="cursor:pointer;min-width:75px;">
                                <strong>
                                  {{ $ml.get('employees.registrationNumberInfo') }}
                                  <i v-show="orderEmpList == 1" class="fa fa-sort-numeric-asc"></i>
                                  <i v-show="orderEmpList == 2" class="fa fa-sort-numeric-desc"></i>
                                </strong>
                              </td>
                              <td @click="setOrderEmp(2)" style="cursor:pointer;">
                                <strong>
                                  {{ $ml.get('employees.nameSurname') }}
                                  <i v-show="orderEmpList == 3" class="fa fa-sort-alpha-asc"></i>
                                  <i v-show="orderEmpList == 4" class="fa fa-sort-alpha-desc"></i>
                                </strong>
                              </td>
                            </tr>
                          </thead>
                          <tbody>
                            <tr style="cursor:pointer;" v-for="employee3 in filtered" :key="'employee' + employee3.id"
                              @click="employee3.check == true ? employee3.check = false : employee3.check = true">
                              <td style="font-size:18px;">
                                <i v-if="employee3.check" class="fa fa-check-circle text-success"></i>
                                <i v-else class="fa fa-times-circle text-danger"></i>
                              </td>
                              <td>{{ employee3.sicilNo }}</td>
                              <td>
                                {{ employee3.name }}
                                <span v-if="employee3.title != ''">({{ employee3.title }})</span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div v-show="employeeFilteredList.length == 0" class="callout callout-info">
                        <i class="fa fa-info-circle"></i>
                        {{ $ml.get('filters.employeeNotRecord') }}
                      </div>
                    </div>
                    <div class="overlay" id="load" :hidden="!isLoadingEmployee">
                      <i class="fa fa-refresh fa-spin"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 text-right">
                  <button type="button" class="btn btn-primary" @click="activeScreen = 2">
                    <i class="fa fa-check"></i>
                    <span>{{ $ml.get('filters.filterComplete') }}</span>
                  </button>
                </div>
              </div>
              <div v-show="activeScreen == 2" :class="activeScreen == 2 ? 'row tab-pane active' : 'row tab-pane'"
                style="margin-top: 10px;"><!-- RAPOR SEÇİM -->
                <div class="col-sm-12">
                  <div class="box box-primary">
                    <div class="box-header">
                      <h3 class="box-title" align="center">{{ $ml.get('reports.selectReport') }}</h3>
                    </div>
                    <div class="box-body">
                      <div class="row">
                        <div class="col-sm-6">
                          <h4>{{ $ml.get('reports.reportSettings') }}</h4>
                          <div class="input-group" style="margin-bottom:5px;">
                            <span class="input-group-addon">{{ $ml.get('reports.report') }} :</span>
                            <select @change="changeSelectedReport($event)" class="form-control">
                              <option value>{{ $ml.get('reports.selectReport') }}</option>
                              <option v-for="report in reportList" :key="'report' + report.id" :value="report.id">{{
                                report.name
                              }}
                              </option>
                            </select>
                          </div>
                          <div class="input-group" style="width:100%; margin-bottom:5px;">
                            <span class="input-group-addon">
                              <span v-show="selectedReportId != 14 || selectedReportId != 15">{{
                                $ml.get('reports.startDate') }}
                                :</span>
                              <span v-show="selectedReportId == 14 || selectedReportId == 15">{{ $ml.get('reports.date')
                              }}
                                :</span>
                            </span>
                            <input v-model="startDate" type="datetime-local" class="form-control" />
                          </div>
                          <div
                            v-show="selectedReportId != 6 && selectedReportId != 7 && selectedReportId != 14 && selectedReportId != 15"
                            class="input-group" style="margin-bottom:5px;">
                            <span class="input-group-addon">{{ $ml.get('reports.endDate') }} :</span>
                            <input v-model="endDate" type="datetime-local" class="form-control" />
                          </div>
                          <div v-show="selectedReportId == 1 || selectedReportId == 10 || selectedReportId == 11">
                            <hr />
                            <h4>{{ $ml.get('reports.reportOptions') }}</h4>
                            <hr />
                            <span class="form-control checkbox mt-2 no-border"
                              v-show="selectedReportId == 1 || selectedReportId == 11">
                              <label style="margin-left:20px;">
                                <input :checked="reportOptions.showAllowed"
                                  @change="reportOptions.showAllowed == true ? reportOptions.showAllowed = false : reportOptions.showAllowed = true"
                                  type="checkbox" />
                                {{ $ml.get('reports.showAllowences') }}
                              </label>
                            </span>
                            <span class="form-control checkbox mt-2 no-border"
                              v-show="selectedReportId == 11 || selectedReportId == 10">
                              <label style="margin-left:20px;">
                                <input :checked="reportOptions.showNonComers"
                                  @change="reportOptions.showNonComers == true ? reportOptions.showNonComers = false : reportOptions.showNonComers = true"
                                  type="checkbox" />
                                {{ $ml.get('reports.showMissing') }}
                              </label>
                            </span>
                            <span class="form-control checkbox mt-2 no-border" v-show="selectedReportId == 1">
                              <label style="margin-left:20px;">
                                <input :checked="reportOptions.showLateComers"
                                  @change="reportOptions.showLateComers == true ? reportOptions.showLateComers = false : reportOptions.showLateComers = true"
                                  type="checkbox" />
                                {{ $ml.get('reports.showLatecomer') }}
                              </label>
                            </span>
                            <div v-show="selectedReportId == 10" class="input-group mt-2">
                              <input class="form-control input-lg" type="number" min="1"
                                v-model="reportOptions.time" />
                              <span class="input-group-addon">{{ $ml.get('reports.fromTheClock') }}</span>
                              <select @change="changeIsUpperFromTime($event)" class="form-control input-lg">
                                <option :selected="reportOptions.isUpperFromTime == false" value="false">
                                  {{ $ml.get('reports.lessEmployees') }}</option>
                                <option :selected="reportOptions.isUpperFromTime == true" value="true">
                                  {{ $ml.get('reports.moreEmployees') }}</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-6">
                          <div v-show="selectedReportId == 8">
                            <h4>
                              {{ $ml.get('reports.displayInReportVisitorCardGroups') }}
                              <span @click="checkAllVisitorGroups()" style="cursor:pointer;color:red;font-size:15px;"
                                v-text="isCheckVG ? $ml.get('general.removeAll') : $ml.get('general.selectAll')"></span>
                            </h4>
                            <div v-show="visitorGroupList.length > 0" class="table-responsive no-padding"
                              :style="windowHeightTableSize">
                              <table class="table table-hover">
                                <tbody>
                                  <tr style="cursor:pointer;" v-for="visitorGroup in visitorGroupList"
                                    :key="visitorGroup.id"
                                    @click="visitorGroup.check == true ? visitorGroup.check = false : visitorGroup.check = true">
                                    <td style="font-size:18px;">
                                      <i v-if="visitorGroup.check" class="fa fa-check-circle text-success"></i>
                                      <i v-else class="fa fa-times-circle text-danger"></i>
                                    </td>
                                    <td>{{ visitorGroup.name }}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div v-show="visitorGroupList.length == 0" class="callout callout-info">
                              <i class="fa fa-info-circle"></i>
                              {{ $ml.get('reports.visitorCardGroupNotFound') }}
                            </div>
                          </div>
                          <div
                            v-show="selectedReportId == 1 || selectedReportId == 2 || selectedReportId == 6 || selectedReportId == 7 || selectedReportId == 11 || selectedReportId == 19 || selectedReportId == 20 || selectedReportId == 21 || selectedReportId == 31">
                            <h4>
                              {{ $ml.get('reports.displayInReportDevices') }}
                              <span @click="checkAllReaders()" style="cursor:pointer;color:red;font-size:15px;"
                                v-text="isCheckReaders ? $ml.get('general.removeAll') : $ml.get('general.selectAll')"></span>
                            </h4>
                            <div class="input-group">
                              <span class="input-group-addon">{{ $ml.get('reports.checkThisDevices') }} :</span>
                              <select @change="changeInOutListDoorType($event)" class="form-control">
                                <option :selected="selectedDoorType == 4" value="4">{{ $ml.get('employees.allDoors') }}
                                </option>
                                <option :selected="selectedDoorType == 0" value="0">{{ $ml.get('employees.access') }}
                                </option>
                                <option :selected="selectedDoorType == 1" value="1">{{ $ml.get('employees.pdks') }}
                                </option>
                                <option v-show="modules.diningHall" :selected="selectedDoorType == 2" value="2">
                                  {{ $ml.get('employees.diningHall') }}</option>
                                <option v-show="modules.licencePlateRecognition" :selected="selectedDoorType == 3"
                                  value="3">
                                  {{ $ml.get('employees.licencePlateRecognition') }}</option>
                                <option v-show="modules.dormitory" :selected="selectedDoorType == 5" value="5">
                                  {{ $ml.get('employees.dormitoryDevice') }}</option>
                              </select>
                            </div>
                            <div v-show="readerList.length > 0" class="table-responsive no-padding"
                              :style="windowHeightTableSize">
                              <table class="table table-hover">
                                <tbody>
                                  <tr style="cursor:pointer;" v-for="reader in readerList"
                                    :key="'reader' + reader.readerId"
                                    @click="reader.check == true ? reader.check = false : reader.check = true">
                                    <td style="font-size:18px;">
                                      <i v-if="reader.check" class="fa fa-check-circle text-success"></i>
                                      <i v-else class="fa fa-times-circle text-danger"></i>
                                    </td>
                                    <td>{{ reader.ipAddress }}</td>
                                    <td>{{ reader.name }}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div v-show="readerList.length == 0" class="callout callout-info">
                              <i class="fa fa-info-circle"></i>
                              {{ $ml.get('reports.devicesNotFound') }}
                            </div>
                          </div>
                          <div v-show="selectedReportId == 12">
                            <h4>
                              {{ $ml.get('reports.displayInReportAllowences') }}
                              <span @click="checkAllAllowence()" style="cursor:pointer;color:red;font-size:15px;"
                                v-text="isCheckAllowences ? $ml.get('general.removeAll') : $ml.get('general.selectAll')"></span>
                            </h4>
                            <div v-show="allowenceList.length > 0" class="table-responsive no-padding"
                              :style="windowHeightTableSize">
                              <table class="table table-hover">
                                <tbody>
                                  <tr style="cursor:pointer;" v-for="allowence in allowenceList"
                                    :key="'allowence' + allowence.id"
                                    @click="allowence.check == true ? allowence.check = false : allowence.check = true">
                                    <td style="font-size:18px;">
                                      <i v-if="allowence.check" class="fa fa-check-circle text-success"></i>
                                      <i v-else class="fa fa-times-circle text-danger"></i>
                                    </td>
                                    <td>{{ allowence.shortCode }} - {{ allowence.name }}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div v-show="allowenceList.length == 0" class="callout callout-info">
                              <i class="fa fa-info-circle"></i>
                              {{ $ml.get('reports.allowenceNotFound') }}
                            </div>
                          </div>
                          <div
                            v-show="selectedReportId == 14 || selectedReportId == 15 || selectedReportId == 25 || selectedReportId == 30">
                            <h4>
                              {{ $ml.get('reports.displayInReportDepartments') }}
                              <span v-show="isCheckDeps" @click="getCheckDepartmentAll(false)"
                                style="cursor:pointer;color:red;font-size:15px;">{{ $ml.get('general.removeAll')
                                }}</span>
                              <span v-show="!isCheckDeps" @click="getCheckDepartmentAll(true)"
                                style="cursor:pointer;color:red;font-size:15px;">{{ $ml.get('general.selectAll')
                                }}</span>
                            </h4>
                            <div v-show="departmentList.length > 0" class="table-responsive no-padding text-black"
                              :style="'background-style:white; ' + windowHeightTableSize">
                              <table class="table table-hover">
                                <tbody>
                                  <tr style="cursor:pointer;" v-for="dep in sortableDepartmentList"
                                    :key="'department' + dep.id"
                                    @click="dep.check == true ? changeFilterDep2(dep, false) : changeFilterDep2(dep, true)">
                                    <td style="font-size:18px;">
                                      <i v-if="dep.check" class="fa fa-check-circle text-success"></i>
                                      <i v-else class="fa fa-times-circle text-danger"></i>
                                    </td>
                                    <td>{{ dep.name }}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div v-show="departmentList.length == 0" class="callout callout-info">
                              <i class="fa fa-info-circle"></i>
                              {{ $ml.get('reports.departmentNotFound') }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="box-footer text-right">
                      <button @click="getReportDetails()" class="btn btn-primary">
                        <i class="fa fa-file-text"></i>
                        {{ $ml.get('reports.viewReport') }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div v-show="activeScreen == 3" :class="activeScreen == 3 ? 'row tab-pane active' : 'row tab-pane'"
                style="margin-top: 10px;"><!-- RAPOR SONUCU -->
                <div class="col-sm-12">
                  <div class="box box-primary">
                    <div class="box-header">
                      <h3 class="box-title" align="center">
                        <span v-show="selectedReportName != ''">{{ selectedReportName }}</span>
                        <span v-show="selectedReportName == ''">{{ $ml.get('reports.report') }}</span>
                      </h3>
                      <div class="box-tools pull-right" v-show="authControl == 0 && reportDataList != null">
                        <button @click="exportToExcel()" type="button" class="btn btn-success">
                          <i class="fa fa-share"></i>
                          {{ $ml.get('general.exportToExcel') }}
                        </button>
                        <button @click="exportToPDF()" type="button" class="btn btn-danger">
                          <i class="fa fa-share"></i>
                          {{ $ml.get('general.exportToPdfOrPrint') }}
                        </button>
                      </div>
                    </div>
                    <div class="box-body">
                      <div id="printReport" v-show="reportDataList != null" class="table-responsive no-padding"
                        :style="windowHeightSize">
                        <div align="center">
                          <span class="mb-10 text-center" v-show="selectedReportName != ''">{{ selectedReportName }}
                            ({{ this.startDate | toDateFormatGet("gg.aa.yyyy ss:dd") }} - {{ this.endDate |
                              toDateFormatGet("gg.aa.yyyy ss:dd") }})</span>
                        </div>
                        <table id="printExcel" class="table table-hover" style="font-size:12px;">
                          <thead>
                            <tr>
                              <th class="dep-baslik" v-for="(header, indexHead) in reportHeaderList"
                                :key="'head' + indexHead">
                                {{ header }}</th>
                            </tr>
                          </thead>
                          <tbody v-for="(dep, index) in reportDataList" :key="'body' + index">
                            <tr>
                              <td class="dep-baslik" :colspan="selectedReportId == 1 ? 7 : 37">
                                <strong>{{ dep.departmanAdi }}</strong>
                              </td>
                            </tr>
                            <tr v-for="(data, index2) in dep.veriler" :key="'data' + index2"
                              :class="index2 % 2 == 1 ? 'bg-secondary' : ''">
                              <td v-for="(key1, indexKey) in dep.keys" :class="customReportStyle(key1, data[key1])"
                                :key="'key' + indexKey">
                                <span v-if="selectedReportId == 19 && indexKey == 4 && data.positionX">
                                  <a v-if="data.positionX" style="margin-top:10px;" target="_blank"
                                    :href="'http://maps.google.com/maps?f=q&hl=en&q=' + data.positionX + '+N,+' + data.positionY + '+E&ie=UTF8&t=k&om=0&ll=' + data.positionX + ',' + data.positionY + '&spn=0.003022,0.004989&t=k'">{{
                                      data.positionX }}
                                    - {{ data.positionY }}</a>
                                </span>
                                <span
                                  v-show="(selectedReportId == 32 && indexKey != 5) || (selectedReportId != 31 && selectedReportId != 32) || (selectedReportId == 31 && indexKey != 6 && indexKey != 7)">{{
                                    data[key1] }}</span>
                                <span v-if="selectedReportId == 32 && indexKey == 5 && data[key1]">
                                  <i class="fa fa-times-circle text-danger"></i> İade Edildi
                                </span>
                                <img v-if="selectedReportId == 31 && (indexKey == 6 || indexKey == 7)"
                                  style="width:200px;" :src="data[key1]" />
                              </td>
                              <td v-for="(movement, index) in data.movements" :key="'visitorKey' + index"
                                class="no-wrap">
                                <strong v-show="movement.entryTime">GİRİŞ</strong><br v-show="movement.entryTime" />
                                <span v-show="movement.entryTime" class="text-success">{{ movement.entryTime }}</span>
                                <br v-show="movement.entryTime" /> {{ movement.entryReaderName }} <br />
                                <strong v-show="movement.exitTime">ÇIKIŞ</strong><br v-show="movement.exitTime" />
                                <span v-show="movement.exitTime" class="text-danger">{{ movement.exitTime }}</span> <br
                                  v-show="movement.exitTime" /> {{ movement.exitReaderName }} <br />
                                <strong v-show="movement.timeDifference">FARK</strong><br
                                  v-show="movement.timeDifference" />
                                <span v-show="movement.timeDifference" class="text-primary">{{ movement.timeDifference
                                }}</span>
                                <br v-show="movement.timeDifference" />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div class="pull-right" style="margin-right: 70px; margin-bottom: 40px;">
                          <!--<strong>Toplam Kayıt :</strong>
                  <span
                    v-text="reportDataList != null || reportDataList == 0 ? reportDataList.length : 0"
                  ></span>-->
                        </div>
                      </div>
                      <div v-show="reportDataList == null || reportDataList == 0" class="callout callout-info">
                        <i class="fa fa-info-circle"></i>
                        {{ $ml.get('reports.noResults') }}
                      </div>
                    </div>
                    <div class="overlay" id="load" :hidden="!isLoading">
                      <i class="fa fa-refresh fa-spin"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--DEPARTMAN SEÇ MODAL -->
      <div class="modal modal-secondary fade" id="modal-select-department" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('filters.filterDepartments') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <a @click="isCheckDeps == true ? getCheckDepartmentAll(false) : getCheckDepartmentAll(true)">
                <span v-text="isCheckDeps == true ? $ml.get('general.removeAll') : $ml.get('general.selectAll')"></span>
              </a>
              <div class="table-responsive" style="max-height:600px;owerflow:auto;">
                <span class="form-control checkbox" v-for="dep in sortableDepartmentList" :key="'sortDep' + dep.id">
                  <label style="margin-left:20px;">
                    <input :checked="dep.check"
                      @change="dep.check == true ? changeFilterDep(dep, false) : changeFilterDep(dep, true)"
                      type="checkbox" />
                    {{ dep.name }}
                  </label>
                </span>
                <div class="callout callout-warning" v-show="sortableDepartmentList.length == 0">
                  {{ $ml.get('employees.departmentNotRecord') }}</div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" M data-dismiss="modal">
                <i class="fa fa-check"></i>
                {{ $ml.get('general.done') }}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--DEPARTMAN SEÇ MODAL END -->
      <!--DURUM SEÇ MODAL -->
      <div class="modal modal-secondary fade" id="modal-select-state" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('filters.filterState') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="table-responsive" style="max-height:600px;owerflow:auto;">
                <span class="form-control checkbox" v-for="state in stateList" :key="'state' + state.id">
                  <label style="margin-left:20px;">
                    <input :checked="state.isCheck"
                      @change="state.isCheck == true ? state.isCheck = false : state.isCheck = true" type="checkbox" />
                    {{ state.name }}
                  </label>
                </span>
                <div class="callout callout-warning" v-show="stateList.length == 0">
                  {{ $ml.get('employees.stateNotRecord') }}</div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fa fa-check"></i>
                {{ $ml.get('general.done') }}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--DURUM SEÇ MODAL END -->
      <!--STATU SEÇ MODAL -->
      <div class="modal modal-secondary fade" id="modal-select-status" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('filters.filterStatus') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="table-responsive" style="max-height:600px;owerflow:auto;">
                <span class="form-control checkbox" v-for="status in statuList" :key="'status' + status.id">
                  <label style="margin-left:20px;">
                    <input :checked="status.isCheck"
                      @change="status.isCheck == true ? status.isCheck = false : status.isCheck = true"
                      type="checkbox" />
                    {{ status.name }}
                  </label>
                </span>
                <div class="callout callout-warning" v-show="statuList.length == 0">
                  {{ $ml.get('employees.statusNotRecord') }}</div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fa fa-check"></i>
                {{ $ml.get('general.done') }}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--STATU SEÇ MODAL END -->
      <!--GEÇİŞ GRUBU SEÇ MODAL -->
      <div class="modal modal-secondary fade" id="modal-select-access" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('filters.filterAccessGroup') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="table-responsive" style="max-height:600px;owerflow:auto;">
                <span class="form-control checkbox" v-for="acc in accessGroupList" :key="'access' + acc.id">
                  <label style="margin-left:20px;">
                    <input :checked="acc.isCheck"
                      @change="acc.isCheck == true ? acc.isCheck = false : acc.isCheck = true" type="checkbox" />
                    {{ acc.name }}
                  </label>
                </span>
                <div class="callout callout-warning" v-show="accessGroupList.length == 0">
                  {{ $ml.get('accessGroups.accessGroupNotRecord') }}</div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fa fa-check"></i>
                {{ $ml.get('general.done') }}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--GEÇİŞ GRUBU SEÇ MODAL END -->
      <!--ÇALIŞMA PLANI SEÇ MODAL -->
      <div class="modal modal-secondary fade" id="modal-select-workplan" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('filters.filterWorkPlan') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="table-responsive" style="max-height:600px;owerflow:auto;">
                <span class="form-control checkbox" v-for="work in workGroupList" :key="'workGroup' + work.id">
                  <label style="margin-left:20px;">
                    <input :checked="work.isCheck"
                      @change="work.isCheck == true ? work.isCheck = false : work.isCheck = true" type="checkbox" />
                    {{ work.name }}
                  </label>
                </span>
                <div class="callout callout-warning" v-show="workGroupList.length == 0">
                  {{ $ml.get('workPlans.workPlanNotRecord') }}</div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fa fa-check"></i>
                {{ $ml.get('general.done') }}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--ÇALIŞMA PLANI SEÇ MODAL END -->
      <!--YEMEK PLANI SEÇ MODAL -->
      <div class="modal modal-secondary fade" id="modal-select-diningHall" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('filters.filterWorkPlan') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="table-responsive" style="max-height:600px;owerflow:auto;">
                <span class="form-control checkbox" v-for="foodGroup in foodGroupList"
                  :key="'foodGroup' + foodGroup.id">
                  <label style="margin-left:20px;">
                    <input :checked="foodGroup.isCheck"
                      @change="foodGroup.isCheck == true ? foodGroup.isCheck = false : foodGroup.isCheck = true"
                      type="checkbox" />
                    {{ foodGroup.name }}
                  </label>
                </span>
                <div class="callout callout-warning" v-show="foodGroupList.length == 0">
                  {{ $ml.get('foodGroups.foodGroupNotRecord') }}</div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fa fa-check"></i>
                {{ $ml.get('general.done') }}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--YEMEK PLANI SEÇ MODAL END -->
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      isLoadingEmployee: false,
      activeScreen: 1,
      orderEmpList: 1,
      selectedDoorType: 4,
      filters: {
        nameOrCardNumber: "",
        sicilOrTerminalNo: null,
        departments: [],
        accessGroup: [],
        identityNo: "",
        documentNoOrMail: "",
        foodGroup: [],
        workGroupId: [],
        title: "",
        stateId: [],
        statuId: [],
        plateNo: "",
        extraField1key: 0,
        extraField1value: "",
        extraField2key: 0,
        extraField2value: "",
        extraField3key: 0,
        extraField3value: "",
        extraField4key: 0,
        extraField4value: "",
        isVisitor: false,
        isActive: true
      },
      sortableDepTrees: [],
      isCheckDeps: false,
      isCheck: true,
      employees: [],
      departments: [],
      foodGroups: [],
      titles: [],
      states: [],
      status: [],
      extrafields: [],
      workGroups: [],
      accessGroups: [],
      isCheckVG: true,
      visitorGroups: [],
      isCheckAllowences: true,
      allowences: [],
      isCheckReaders: true,
      readers: [],
      startDate: null,
      endDate: null,
      selectedReportId: 0,
      selectedReportEndPoint: "",
      selectedReportName: "",
      selectedDevices: [],
      selectedAllowences: [],
      selectedVisitorGroups: [],
      reportOptions: {
        showAllowed: true,
        showNonComers: true,
        showLateComers: false,
        isUpperFromTime: false,
        time: 45
      },
      reportDatas: null,
      reportHeaders: null,
      reportResult: [],
      reportName: "",
      searchText: "",
      activeReports: [],
      reports: [
        //max index:35, max id:36
        {
          id: 32,
          name: this.$ml.get("reports.reports.SaleReport"),
          endPoint: "SaleReport",
          isActive: false,
          index: 31,
          module: this.$store.getters.getModules.retailSale
        },
        {
          id: 33,
          name: this.$ml.get("reports.reports.DetailedVisitorReport"),
          endPoint: "VisitorDetailedReport",
          isActive: false,
          index: 30,
          module: this.$store.getters.getModules.visitor
        },
        {
          id: 34,
          name: this.$ml.get("reports.reports.DepartmentBasedVisitorReport"),
          endPoint: "DepartmentBasedVisitorReport",
          isActive: false,
          index: 33,
          module: this.$store.getters.getModules.visitor
        },
        {
          id: 31,
          name: this.$ml.get("reports.reports.EntryExitSnapshotReport"),
          endPoint: "EntryExitSnapshotReport",
          isActive: false,
          index: 32,
          module: true
        },
        {
          id: 1,
          name: this.$ml.get("reports.reports.LaterComersReport"),
          endPoint: "LaterComersReport",
          isActive: false,
          index: 2,
          module: true
        },
        {
          id: 2,
          name: this.$ml.get("reports.reports.DetailedInOutReport"),
          endPoint: "DetailedInOutReport",
          isActive: false,
          index: 8,
          module: true
        },
        {
          id: 3,
          name: this.$ml.get("reports.reports.FoodReport"),
          endPoint: "FoodReport",
          isActive: false,
          index: 22,
          module: this.$store.getters.getModules.diningHall
        },
        {
          id: 4,
          name: this.$ml.get("reports.reports.FoodDebtReport"),
          endPoint: "FoodDebtReport",
          isActive: false,
          index: 23,
          module: this.$store.getters.getModules.diningHall
        },
        {
          id: 5,
          name: this.$ml.get("reports.reports.EmployeesReport"),
          endPoint: "EmployeesReport",
          isActive: false,
          index: 0,
          module: true
        },
        {
          id: 6,
          name: this.$ml.get("reports.reports.InsidesReport"),
          endPoint: "InsidesReport",
          isActive: false,
          index: 4,
          module: true
        },
        {
          id: 7,
          name: this.$ml.get("reports.reports.OutsidesReport"),
          endPoint: "OutsidesReport",
          isActive: false,
          index: 5,
          module: true
        },
        {
          id: 8,
          name: this.$ml.get("reports.reports.VisitorsReport"),
          endPoint: "VisitorsReport",
          isActive: false,
          index: 20,
          module: this.$store.getters.getModules.visitor
        },
        {
          id: 9,
          name: this.$ml.get("reports.reports.InsideVisitorsReport"),
          endPoint: "InsideVisitorsReport",
          isActive: false,
          index: 21,
          module: this.$store.getters.getModules.visitor
        },
        {
          id: 10,
          name: this.$ml.get("reports.reports.TimeBasedWorkReport"),
          endPoint: "TimeBasedWorkReport",
          isActive: false,
          index: 10,
          module: true
        },
        {
          id: 11,
          name: this.$ml.get("reports.reports.FirstInLastOutReport"),
          endPoint: "FirstInLastOutReport",
          isActive: false,
          index: 9,
          module: true
        },
        {
          id: 12,
          name: this.$ml.get("reports.reports.AllowenceReport"),
          endPoint: "AllowenceReport",
          isActive: false,
          index: 3,
          module: true
        },
        {
          id: 13,
          name: this.$ml.get("reports.reports.WorkSummaryReport"),
          endPoint: "WorkSummaryReport",
          isActive: false,
          index: 11,
          module: true
        },
        {
          id: 14,
          name: this.$ml.get("reports.reports.CompanyEmployeesStatusReport"),
          endPoint: "CompanyEmployeesStatusReport",
          isActive: false,
          index: 12,
          module: true
        },
        {
          id: 15,
          name: this.$ml.get(
            "reports.reports.CustomCompanyEmployeesStatusReport"
          ),
          endPoint: "CustomCompanyEmployeesStatusReport",
          isActive: false,
          index: 13,
          module: true
        },
        {
          id: 16,
          name: this.$ml.get("reports.reports.PayrollReport"),
          endPoint: "PayrollReport",
          isActive: false,
          index: 14,
          module: true
        },
        {
          id: 17,
          name: this.$ml.get("reports.reports.DetailedPayrollReport"),
          endPoint: "DetailedPayrollReport",
          isActive: false,
          index: 15,
          module: true
        },
        {
          id: 29,
          name: this.$ml.get("reports.reports.WeeklyPayrollReport"),
          endPoint: "WeeklyPayrollReport",
          isActive: false,
          index: 15,
          module: true
        },
        {
          id: 26,
          name: this.$ml.get("reports.reports.TemplatePayrollReport"),
          endPoint: "TemplatePayrollReport",
          isActive: false,
          index: 16,
          module: this.$store.getters.getModules.payroll
        },
        {
          id: 27,
          name: this.$ml.get("reports.reports.TemplateMonthlyPayrollReport"),
          endPoint: "TemplateMonthlyPayrollReport",
          isActive: false,
          index: 17,
          module: this.$store.getters.getModules.payroll
        },
        {
          id: 28,
          name: this.$ml.get("reports.reports.SalaryReport"),
          endPoint: "SalaryReport",
          isActive: false,
          index: 18,
          module: this.$store.getters.getModules.payroll
        },
        {
          id: 30,
          name: this.$ml.get("reports.reports.DepartmentSummaryReport"),
          endPoint: "DepartmentSummaryReport",
          isActive: false,
          index: 19,
          module: true
        },
        {
          id: 18,
          name: this.$ml.get("reports.reports.FoodCreditReport"),
          endPoint: "FoodCreditReport",
          isActive: false,
          index: 24,
          module: this.$store.getters.getModules.diningHall
        },
        {
          id: 19,
          name: this.$ml.get("reports.reports.InOutReport"),
          endPoint: "InOutReport",
          isActive: false,
          index: 7,
          module: true
        },
        {
          id: 20,
          name: this.$ml.get("reports.reports.DoorBasedLastMovementReport"),
          endPoint: "DoorBasedLastMovementReport",
          isActive: false,
          index: 6,
          module: true
        },
        {
          id: 21,
          name: this.$ml.get("reports.reports.DoorsAuthorizationReport"),
          endPoint: "DoorsAuthorizationReport",
          isActive: false,
          index: 1,
          module: true
        },
        {
          id: 22,
          name: this.$ml.get("reports.reports.DormitoryInformationReport"),
          endPoint: "DormitoryInformationReport",
          isActive: false,
          index: 26,
          module: this.$store.getters.getModules.dormitory
        },
        {
          id: 23,
          name: this.$ml.get("reports.reports.DormitoryInsidesReport"),
          endPoint: "DormitoryInsidesReport",
          isActive: false,
          index: 27,
          module: this.$store.getters.getModules.dormitory
        },
        {
          id: 24,
          name: this.$ml.get("reports.reports.DormitoryOutsidesReport"),
          endPoint: "DormitoryOutsidesReport",
          isActive: false,
          index: 28,
          module: this.$store.getters.getModules.dormitory
        },
        {
          id: 25,
          name: this.$ml.get("reports.reports.FoodSummaryReport"),
          endPoint: "FoodSummaryReport",
          isActive: false,
          index: 29,
          module: this.$store.getters.getModules.diningHall
        },
        {
          id: 35,
          name: this.$ml.get("reports.reports.ShiftReport"),
          endPoint: "ShiftReport",
          isActive: false,
          index: 34,
          module: true
        },
        {
          id: 36,
          name: this.$ml.get("reports.reports.VerticalFirstInLastOutReport"),
          endPoint: "VerticalFirstInLastOutReport",
          isActive: false,
          index: 35,
          module: true
        },
      ]
    };
  },
  computed: {
    defaultFilters() {
      return this.$store.getters.getDefaultFilters;
    },
    modules() {
      return this.$store.getters.getModules;
    },
    authControl() {
      return this.$store.getters.getAuthRaporlar;
    },
    checkedDepartmentList() {
      var checkedList = "";
      var list = this.sortableDepartmentList.forEach(a => {
        if (a.check == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    checkedStateList() {
      var checkedList = "";
      var list = this.stateList.forEach(a => {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    checkedStatusList() {
      var checkedList = "";
      var list = this.statuList.forEach(a => {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    checkedWorkGroupList() {
      var checkedList = "";
      var list = this.workGroupList.forEach(a => {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    checkedAccessGroupList() {
      var checkedList = "";
      var list = this.accessGroupList.forEach(a => {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    checkedFoodGroupList() {
      var checkedList = "";
      var list = this.foodGroupList.forEach(a => {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    employeeFilteredList() {
      if (this.orderEmpList == 1) {
        return this.employees.sort((a, b) => {
          return this.turkishToUpper(a.sicilNo).localeCompare(
            this.turkishToUpper(b.sicilNo)
          );
        });
      } else if (this.orderEmpList == 2) {
        return this.employees.sort((a, b) => {
          return this.turkishToUpper(b.sicilNo).localeCompare(
            this.turkishToUpper(a.sicilNo)
          );
        });
      } else if (this.orderEmpList == 3) {
        return this.employees.sort((a, b) => {
          return this.turkishToUpper(a.name).localeCompare(
            this.turkishToUpper(b.name)
          );
        });
      } else {
        return this.employees.sort((a, b) => {
          return this.turkishToUpper(b.name).localeCompare(
            this.turkishToUpper(a.name)
          );
        });
      }
    },
    departmentList() {
      return this.departments;
    },
    sortableDepartmentList() {
      return this.sortableDepTrees;
    },
    foodGroupList() {
      return this.foodGroups;
    },
    titleList() {
      return this.titles;
    },
    stateList() {
      return this.states;
    },
    statuList() {
      return this.status;
    },
    visitorGroupList() {
      return this.visitorGroups;
    },
    readerList() {
      return this.readers.sort((a, b) => {
        if (a.ipAddress < b.ipAddress) return -1;
        if (a.ipAddress > b.ipAddress) return 0;
      });
    },
    reportList() {
      var list = this.reports.filter(item => {
        return item.isActive == true && item.module == true;
      });
      if (list) {
        return list.sort((a, b) => {
          if (a.index < b.index) return -1;
          if (a.index > b.index) return 0;
        });
      }
    },
    reportDataList() {
      return this.reportDatas;
    },
    reportHeaderList() {
      return this.reportHeaders;
    },
    extraFieldList() {
      return this.extrafields;
    },
    workGroupList() {
      return this.workGroups;
    },
    allowenceList() {
      return this.allowences;
    },
    accessGroupList() {
      return this.accessGroups;
    },
    filtered() {
      var search = this.turkishToUpper(this.searchText);
      if (search) {
        return this.employeeFilteredList.filter(item => {
          return search
            .split(" ")
            .every(v => this.turkishToUpper(item.name).includes(v));
        });
      } else {
        return this.employeeFilteredList;
      }
    },
    windowHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 300;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    },
    windowHeightTableSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 380;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  filters: {
    toDateFormatGet(str, format) {
      if (str == "" || str == null) {
        return "";
      }
      if (format == "gg.aa.yyyy ss:dd") {
        str = new Date(str);
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        str = new Date(str);
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return gun + "." + ay + "." + yil;
      } else if (format == "ss:dd:ss") {
        if (str.length > 5) {
          str = new Date(str);
          var saat =
            str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
          var dakika =
            str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
          return saat + ":" + dakika;
        } else {
          str = new Date("1900-01-01 " + str.replace("Z", ""));
          var saat =
            str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
          var dakika =
            str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
          var saniye =
            str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
          return saat + ":" + dakika + ":" + saniye;
        }
      } else if (format == "ss:dd") {
        if (str.length > 5) {
          str = new Date(str);
          var saat =
            str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
          var dakika =
            str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
          return saat + ":" + dakika;
        } else {
          str = new Date("1900-01-01 " + str.replace("Z", ""));
          var saat =
            str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
          var dakika =
            str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
          return saat + ":" + dakika;
        }
      }
    }
  },
  watch: {
    windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
        //WEB
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  methods: {
    onResize() {
      this.windowHeight = window.innerHeight;
    },
    turkishToUpper(text) {
      var letters = { i: "İ", ş: "Ş", ğ: "Ğ", ü: "Ü", ö: "Ö", ç: "Ç", ı: "I" };
      text = text.replace(/(([iışğüçö]))/g, function (letter) {
        return letters[letter];
      });
      return text.toUpperCase();
    },
    setOrderEmp(number) {
      if (number == 1) {
        if (this.orderEmpList == 1) {
          this.orderEmpList = 2;
        } else {
          this.orderEmpList = 1;
        }
      } else {
        if (this.orderEmpList == 3) {
          this.orderEmpList = 4;
        } else {
          this.orderEmpList = 3;
        }
      }
    },
    toDateFormat(str, format) {
      if (str.length > 9) {
        str = new Date(str);
      } else {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
      }
      if (format == "gg.aa.yyyy ss:dd") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return yil + "-" + ay + "-" + gun;
      } else if (format == "ss:dd:ss") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye =
          str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    },
    changeInOutListDoorType(event) {
      this.selectedDoorType = event.target.value;
      this.readerList.forEach(a => {
        if (this.selectedDoorType == 4) {
          a.check = true;
        } else {
          if (a.doorType == this.selectedDoorType) {
            a.check = true;
          } else {
            a.check = false;
          }
        }
      });
      this.isCheckReaders = true;
    },
    customReportStyle(key, value) {
      if (key == "durum") {
        if (value == "Gelmedi") {
          return "color-danger no-wrap";
        } else if (
          value == "Geç Kaldı" ||
          value == "Hafta Tatili" ||
          value == "Cumartesi Hakedişi"
        ) {
          return "color-warning no-wrap";
        } else if (value == "Geldi") {
          return "color-success no-wrap";
        } else {
          return "color-primary no-wrap";
        }
      } else if (
        (key == "name" && value == "Toplam") ||
        (key == "date" && value == "Toplam")
      ) {
        return "text-bold h5";
      } else if (key == "unitName") {
        return "text-bold";
      } else if (
        key == "employeesInDepartments" ||
        key == "continuedEmployee" ||
        key == "annualPermit" ||
        key == "report" ||
        key == "missioned" ||
        key == "administrativeLeave" ||
        key == "nonComers" ||
        key == "todayComers" ||
        key == "freePermission"
      ) {
        return "text-bold text-center";
      } else if (key == "adSoyad" || key == "name") {
        return "min-180";
      } else if (key == "total" || key == "ucret" || key == "allowenceName") {
        return "text-bold";
      } else if (key == "g1" && value != "") {
        return "color-success";
      } else if (key == "c1" && value != "") {
        return "color-danger";
      } else if (key == "g2" && value != "") {
        return "color-success";
      } else if (key == "c2" && value != "") {
        return "color-danger";
      } else if (key == "g3" && value != "") {
        return "color-success";
      } else if (key == "c3" && value != "") {
        return "color-danger";
      } else if (key == "g4" && value != "") {
        return "color-success";
      } else if (key == "c4" && value != "") {
        return "color-danger";
      } else if (key == "g5" && value != "") {
        return "color-success";
      } else if (key == "c5" && value != "") {
        return "color-danger";
      } else if (key == "g6" && value != "") {
        return "color-success";
      } else if (key == "c6" && value != "") {
        return "color-danger";
      } else if (key == "g7" && value != "") {
        return "color-success";
      } else if (key == "c7" && value != "") {
        return "color-danger";
      } else if (key == "g8" && value != "") {
        return "color-success";
      } else if (key == "c8" && value != "") {
        return "color-danger";
      } else if (key == "g9" && value != "") {
        return "color-success";
      } else if (key == "c9" && value != "") {
        return "color-danger";
      } else if (key == "g10" && value != "") {
        return "color-success";
      } else if (key == "c10" && value != "") {
        return "color-danger";
      } else if (
        key == "employeesInDepartments" ||
        key == "annualPermit" ||
        key == "report" ||
        key == "administrativeLeave" ||
        key == "freePermission" ||
        key == "missioned" ||
        key == "nonComers" ||
        key == "todayComers" ||
        key == "d1" ||
        key == "d2" ||
        key == "d3" ||
        key == "d4" ||
        key == "d5" ||
        key == "d6" ||
        key == "d7" ||
        key == "d8" ||
        key == "d9" ||
        key == "d10" ||
        key == "d11" ||
        key == "d12" ||
        key == "d13" ||
        key == "d14" ||
        key == "d15" ||
        key == "d16" ||
        key == "d17" ||
        key == "d18" ||
        key == "d19" ||
        key == "d20" ||
        key == "d21" ||
        key == "d22" ||
        key == "d23" ||
        key == "d24" ||
        key == "d25" ||
        key == "d26" ||
        key == "d27" ||
        key == "d28" ||
        key == "d29" ||
        key == "d30" ||
        key == "d31"
      ) {
        return "text-center";
      } else if (
        key == "shortCode1" ||
        key == "shortCode2" ||
        key == "shortCode3" ||
        key == "shortCode4" ||
        key == "shortCode5" ||
        key == "shortCode6" ||
        key == "shortCode7" ||
        key == "shortCode8" ||
        key == "shortCode9" ||
        key == "shortCode10" ||
        key == "shortCode11" ||
        key == "shortCode12" ||
        key == "shortCode13" ||
        key == "shortCode14" ||
        key == "shortCode15" ||
        key == "shortCode16" ||
        key == "shortCode17" ||
        key == "shortCode18" ||
        key == "shortCode19" ||
        key == "shortCode20" ||
        key == "shortCode21" ||
        key == "shortCode22" ||
        key == "shortCode23" ||
        key == "shortCode24" ||
        key == "shortCode25" ||
        key == "shortCode26" ||
        key == "shortCode27" ||
        key == "shortCode28" ||
        key == "shortCode29" ||
        key == "shortCode30" ||
        key == "shortCode31"
      ) {
        return "text-center";
      }
    },
    checkEmployees() {
      this.isCheck = !this.isCheck;
      let aList = this.employees;
      aList.forEach(doc => {
        if (doc.check == !this.isCheck) {
          doc.check = this.isCheck;
        }
      });
    },
    async getSelectedEmployeeList() {
      let aList = this.employees;
      let selectedEmployees = aList.filter(function (employee) {
        return employee.check == true;
      });
      let selectedEmployeeList = [];
      await selectedEmployees.forEach(emp => {
        selectedEmployeeList.push(emp.id);
      });
      return selectedEmployeeList;
    },
    filtersClear() {
      this.filters.nameOrCardNumber = "";
      this.filters.sicilOrTerminalNo = null;
      this.filters.departments = [];
      this.filters.accessGroup = [];
      this.filters.identityNo = "";
      this.filters.documentNoOrMail = "";
      this.filters.foodGroup = [];
      this.filters.workGroupId = [];
      this.filters.title = "";
      this.filters.stateId = [];
      this.filters.statuId = [];
      this.filters.plateNo = "";
      this.filters.extraField1key = 0;
      this.filters.extraField1value = "";
      this.filters.extraField2key = 0;
      this.filters.extraField2value = "";
      this.filters.extraField3key = 0;
      this.filters.extraField3value = "";
      this.filters.extraField4key = 0;
      this.filters.extraField4value = "";
      this.filters.isVisitor = false;
      this.filters.isActive = true;
      this.accessGroupList.forEach(a => {
        a.isCheck = false;
      });
      this.sortableDepartmentList.forEach(a => {
        a.check = false;
      });
      this.foodGroupList.forEach(a => {
        a.isCheck = false;
      });
      this.workGroupList.forEach(a => {
        a.isCheck = false;
      });
      this.stateList.forEach(a => {
        a.isCheck = false;
      });
      this.statuList.forEach(a => {
        a.isCheck = false;
      });
    },
    changeSelectedReport(event) {
      this.selectedReportId = event.target.value;
      var report = this.reportList.filter(item => {
        return item.id == event.target.value;
      });
      if (report) {
        this.selectedReportEndPoint = report[0].endPoint;
        this.selectedReportName = report[0].name;
      }
    },
    changeIsUpperFromTime(event) {
      this.reportOptions.isUpperFromTime = event.target.value;
    },
    changeFilterTitles(event) {
      this.filters.title = event.target.value;
    },
    changeFilterExtraField1(event) {
      this.filters.extraField1key = event.target.value;
    },
    changeFilterExtraField2(event) {
      this.filters.extraField2key = event.target.value;
    },
    changeFilterExtraField3(event) {
      this.filters.extraField3key = event.target.value;
    },
    changeFilterExtraField4(event) {
      this.filters.extraField4key = event.target.value;
    },
    exportToExcel() {
      var tarih = new Date();
      var filename = this.selectedReportName + " - " + tarih.toLocaleString();
      $("#printExcel").table2excel({
        filename: filename + ".xls",
        preserveColors: true
      });
    },
    exportToPDF() {
      this.$htmlToPaper("printReport");
    },
    async getAccessGroups() {
      try {
        const accessGroups = [];
        const response = await this.$axios
          .get("/AccessGroups")
          .then(response => {
            response.data.forEach(doc => {
              accessGroups.push({
                id: doc.id,
                name: doc.name,
                isNewReaderAdd: doc.isNewReaderAdd,
                selectedReaders: doc.postReaders,
                isCheck: false
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.accessGroups = accessGroups;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getDepartments() {
      const departments = [];
      try {
        const response = await this.$axios
          .get("/Department")
          .then(response => {
            response.data.forEach(doc => {
              departments.push({
                id: doc.id,
                name: doc.name,
                mainDepartmentId: doc.mainDepartmentId,
                isActive: doc.isActive,
                locationTree: doc.locationTree,
                userId: doc.userId,
                check: false
              });
            });
            departments.sort((a, b) => {
              if (a.locationTree < b.locationTree) return -1;
              if (a.locationTree > b.locationTree) return 0;
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.departments = departments;
        this.sortableTrees();
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error(error);
      }
    },
    sortableTrees() {
      this.sortableDepTrees = [];
      this.departments.forEach(dep => {
        if (dep.mainDepartmentId == null) {
          this.sortableDepTrees.push(dep);
          this.subDepImport(dep);
        }
      });
    },
    subDepImport(dep) {
      let departments2 = this.departments;
      let subDep = departments2.filter(function (doc) {
        return doc.mainDepartmentId == dep.id;
      });
      if (subDep.length > 0) {
        var ekle = "";
        let ek = subDep[0].locationTree.split("/");
        for (let index = 0; index < ek.length - 3; index++) {
          ekle = "--/" + ekle;
        }
        subDep.forEach(doc2 => {
          doc2.name = ekle + " " + doc2.name;
          this.sortableDepTrees.push(doc2);
          this.subDepImport(doc2);
        });
      }
    },
    async changeFilterDep(dep, checkValue) {
      dep.check = checkValue;
      this.sortableDepartmentList.forEach(doc => {
        if (doc.mainDepartmentId == dep.id) {
          doc.check = checkValue;
          this.changeFilterDep(doc, checkValue);
        }
      });
    },
    async changeFilterDep2(dep, checkValue) {
      dep.check = checkValue;
      this.sortableDepartmentList.forEach(doc => {
        if (doc.mainDepartmentId == dep.id) {
          doc.check = checkValue;
          //this.changeFilterDep(doc, checkValue);
        }
      });
    },
    async clearFilterDepartments() {
      this.filters.departments = [];
      await this.sortableDepartmentList.forEach(doc => {
        if (doc.check == true) {
          doc.check = false;
        }
      });
    },
    async clearFilterAccessGroup() {
      this.filters.accessGroup = [];
      await this.accessGroupList.forEach(doc => {
        if (doc.isCheck == true) {
          doc.isCheck = false;
        }
      });
    },
    async clearFilterStates() {
      this.filters.stateId = [];
      await this.stateList.forEach(doc => {
        if (doc.isCheck == true) {
          doc.isCheck = false;
        }
      });
    },
    async clearFilterStatus() {
      this.filters.statuId = [];
      await this.statuList.forEach(doc => {
        if (doc.isCheck == true) {
          doc.isCheck = false;
        }
      });
    },
    async clearFilterWorkPlans() {
      this.filters.workGroupId = [];
      await this.workGroupList.forEach(doc => {
        if (doc.isCheck == true) {
          doc.isCheck = false;
        }
      });
    },
    async clearFilterFoodGroups() {
      this.filters.foodGroup = [];
      await this.foodGroupList.forEach(doc => {
        if (doc.isCheck == true) {
          doc.isCheck = false;
        }
      });
    },
    async getCheckDepartmentAll(value) {
      this.sortableDepartmentList.forEach(dep => {
        dep.check = value;
      });
      this.isCheckDeps = !this.isCheckDeps;
    },
    async getCheckDepartmentList() {
      let aList = this.sortableDepartmentList;
      this.filters.departments = [];
      await aList.forEach(doc => {
        if (doc.check == true) {
          this.filters.departments.push(doc.id);
        }
      });
      let aList2 = this.accessGroupList;
      this.filters.accessGroup = [];
      await aList2.forEach(doc => {
        if (doc.isCheck == true) {
          this.filters.accessGroup.push(doc.id);
        }
      });
      let aList3 = this.workGroupList;
      this.filters.workGroupId = [];
      await aList3.forEach(doc => {
        if (doc.isCheck == true) {
          this.filters.workGroupId.push(doc.id);
        }
      });
      let aList4 = this.foodGroupList;
      this.filters.foodGroup = [];
      await aList4.forEach(doc => {
        if (doc.isCheck == true) {
          this.filters.foodGroup.push(doc.id);
        }
      });
      let aList5 = this.statuList;
      this.filters.statuId = [];
      await aList5.forEach(doc => {
        if (doc.isCheck == true) {
          this.filters.statuId.push(doc.id);
        }
      });
      let aList6 = this.stateList;
      this.filters.stateId = [];
      await aList6.forEach(doc => {
        if (doc.isCheck == true) {
          this.filters.stateId.push(doc.id);
        }
      });
    },
    async getFoodGroups() {
      try {
        const foodGroups = [];
        const response = await this.$axios
          .get("/FoodGroups")
          .then(response => {
            response.data.forEach(doc => {
              foodGroups.push({
                id: doc.id,
                name: doc.name,
                type: doc.type,
                singleFoodEachMeal: doc.singleFoodEachMeal,
                meals: doc.meals,
                isCheck: false
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.foodGroups = foodGroups;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getStatus() {
      try {
        const status = [];
        const response = await this.$axios
          .get("/Employees/getStatus")
          .then(response => {
            response.data.forEach(doc => {
              status.push({
                id: doc.id,
                name: doc.name,
                isCheck: false
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.status = status;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getTitles() {
      try {
        const titles = [];
        const response = await this.$axios
          .get("/Employees/getTitles")
          .then(response => {
            response.data.forEach(doc => {
              titles.push({
                name: doc
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.titles = titles;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getStates() {
      try {
        const states = [];
        const response = await this.$axios
          .get("/Employees/getStates")
          .then(response => {
            response.data.forEach(doc => {
              states.push({
                id: doc.id,
                name: doc.name,
                isCheck: false
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.states = states;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getWorkGroups() {
      try {
        const workGroups = [];
        const response = await this.$axios
          .get("/WorkGroups")
          .then(response => {
            response.data.forEach(doc => {
              workGroups.push({
                id: doc.id,
                name: doc.name,
                isCheck: false
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.workGroups = workGroups;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getExtraFields() {
      try {
        const extrafields = [];
        const response = await this.$axios
          .get("/ExtraField")
          .then(response => {
            response.data.forEach(doc => {
              extrafields.push({
                id: doc.id,
                name: doc.definition
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.extrafields = extrafields;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async changeAuthReports() {
      this.activeReports.forEach(item => {
        this.reports.forEach(report => {
          if (report.id == item) {
            report.isActive = true;
          }
        });
      });
    },
    async getActiveReports() {
      try {
        const response = await this.$axios
          .get("/Reports")
          .then(response => {
            this.activeReports = response.data;
            this.changeAuthReports();
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async reportSetting() {
      if (this.reportResult != [] && this.reportResult != null) {
        if (this.selectedReportId == 1) {
          //Gelmeyenler Raporu
          this.reportHeaders = [];
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.LaterComersReportHeaders.registrationNumber"
            )
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.LaterComersReportHeaders.nameSurname")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.LaterComersReportHeaders.title")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.LaterComersReportHeaders.date")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.LaterComersReportHeaders.status")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.LaterComersReportHeaders.entry")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.LaterComersReportHeaders.difference")
          );
          var keys = [
            "sicilNo",
            "adSoyad",
            "statu",
            "tarih",
            "durum",
            "girisS",
            "fark"
          ];
          this.reportDatas = [];
          this.reportResult.forEach(item => {
            if (item.veriler.length > 0) {
              this.reportDatas.push({
                departmanAdi: item.departmanAdi,
                keys: keys,
                veriler: item.veriler
              });
              this.reportDatas.sort((a, b) => {
                if (a.departmanAdi < b.departmanAdi) return -1;
                if (a.departmanAdi > b.departmanAdi) return 0;
              });
            }
          });
        } else if (this.selectedReportId == 2) {
          //Detaylı Giriş Çıkış Raporu
          this.reportHeaders = [];
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DetailedInOutReportHeaders.registrationNumber"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DetailedInOutReportHeaders.nameSurname"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DetailedInOutReportHeaders.workPlace"
            )
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.DetailedInOutReportHeaders.date")
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DetailedInOutReportHeaders.firstEntry"
            )
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.DetailedInOutReportHeaders.lastExit")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.DetailedInOutReportHeaders.total")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.DetailedInOutReportHeaders.status")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.DetailedInOutReportHeaders.entry")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.DetailedInOutReportHeaders.exit")
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DetailedInOutReportHeaders.difference"
            )
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.DetailedInOutReportHeaders.entry")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.DetailedInOutReportHeaders.exit")
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DetailedInOutReportHeaders.difference"
            )
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.DetailedInOutReportHeaders.entry")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.DetailedInOutReportHeaders.exit")
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DetailedInOutReportHeaders.difference"
            )
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.DetailedInOutReportHeaders.entry")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.DetailedInOutReportHeaders.exit")
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DetailedInOutReportHeaders.difference"
            )
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.DetailedInOutReportHeaders.entry")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.DetailedInOutReportHeaders.exit")
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DetailedInOutReportHeaders.difference"
            )
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.DetailedInOutReportHeaders.entry")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.DetailedInOutReportHeaders.exit")
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DetailedInOutReportHeaders.difference"
            )
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.DetailedInOutReportHeaders.entry")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.DetailedInOutReportHeaders.exit")
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DetailedInOutReportHeaders.difference"
            )
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.DetailedInOutReportHeaders.entry")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.DetailedInOutReportHeaders.exit")
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DetailedInOutReportHeaders.difference"
            )
          );
          var keys = [
            "sicilNo",
            "adSoyad",
            "workPlace",
            "tarih",
            "ilkG",
            "sonC",
            "total",
            "durum",
            "g1",
            "c1",
            "f1",
            "g2",
            "c2",
            "f2",
            "g3",
            "c3",
            "f3",
            "g4",
            "c4",
            "f4",
            "g5",
            "c5",
            "f5",
            "g6",
            "c6",
            "f6",
            "g7",
            "c7",
            "f7",
            "g8",
            "c8",
            "f8"
          ];
          this.reportDatas = [];
          this.reportResult.forEach(item => {
            if (item.veriler.length > 0) {
              this.reportDatas.push({
                departmanAdi: item.departmanAdi,
                keys: keys,
                veriler: item.veriler
              });
              this.reportDatas.sort((a, b) => {
                if (a.departmanAdi < b.departmanAdi) return -1;
                if (a.departmanAdi > b.departmanAdi) return 0;
              });
            }
          });
        } else if (this.selectedReportId == 3) {
          //Yemekhane Hareket Raporu
          this.reportHeaders = [];
          this.reportHeaders.push(
            this.$ml.get("reports.reports.FoodReportHeader.registrationNumber")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.FoodReportHeader.nameSurname")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.FoodReportHeader.title")
          );
          if (this.modules.customFieldName != "") {
            this.reportHeaders.push(this.modules.customFieldName);
          } else {
            this.reportHeaders.push(
              this.$ml.get("reports.reports.FoodReportHeader.documentNo")
            );
          }
          this.reportHeaders.push(
            this.$ml.get("reports.reports.FoodReportHeader.departmentName")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.FoodReportHeader.readerName")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.FoodReportHeader.date")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.FoodReportHeader.debit")
          );
          var keys = [
            "sicilNo",
            "adSoyad",
            "title",
            "documentNo",
            "departmentName",
            "readerName",
            "tarih",
            "ucret"
          ];
          this.reportDatas = [];
          this.reportResult.forEach(item => {
            if (item.veriler.length > 0) {
              this.reportDatas.push({
                departmanAdi: item.departmanAdi,
                keys: keys,
                veriler: item.veriler
              });
              this.reportDatas.sort((a, b) => {
                if (a.departmanAdi < b.departmanAdi) return -1;
                if (a.departmanAdi > b.departmanAdi) return 0;
              });
            }
          });
        } else if (this.selectedReportId == 4) {
          //Yemekhane Borç Raporu
          this.reportHeaders = [];
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.FoodDebtReportHeaders.registrationNumber"
            )
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.FoodDebtReportHeaders.nameSurname")
          );
          if (this.modules.customFieldName != "") {
            this.reportHeaders.push(this.modules.customFieldName);
          } else {
            this.reportHeaders.push(
              this.$ml.get("reports.reports.FoodDebtReportHeaders.documentNo")
            );
          }
          this.reportHeaders.push(
            this.$ml.get("reports.reports.FoodDebtReportHeaders.debit")
          );
          var keys = ["sicilNo", "adSoyad", "iban", "ucret"];
          this.reportDatas = [];
          this.reportResult.forEach(item => {
            if (item.veriler.length > 0) {
              this.reportDatas.push({
                departmanAdi: item.departmanAdi,
                keys: keys,
                veriler: item.veriler
              });
              this.reportDatas.sort((a, b) => {
                if (a.departmanAdi < b.departmanAdi) return -1;
                if (a.departmanAdi > b.departmanAdi) return 0;
              });
            }
          });
        } else if (this.selectedReportId == 5) {
          //Kişi Bilgileri Raporu
          this.reportHeaders = [];
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.EmployeesReportHeaders.registrationNumber"
            )
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.EmployeesReportHeaders.nameSurname")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.EmployeesReportHeaders.title")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.EmployeesReportHeaders.mobilePhone")
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.EmployeesReportHeaders.citizenshipNumber"
            )
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.EmployeesReportHeaders.status")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.EmployeesReportHeaders.state")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.EmployeesReportHeaders.startDateWork")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.EmployeesReportHeaders.leaveDate")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.EmployeesReportHeaders.validityStartDate")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.EmployeesReportHeaders.validityEndDate")
          );
          var keys = [
            "sicilNo",
            "name",
            "title",
            "mobilePhone",
            "identityNo",
            "statu",
            "state",
            "startDate",
            "leaveDate",
            "validityStartDate",
            "validityEndDate"
          ];
          this.reportDatas = [];
          this.reportResult.forEach(item => {
            if (item.veriler.length > 0) {
              this.reportDatas.push({
                departmanAdi: item.departmanAdi,
                keys: keys,
                veriler: item.veriler
              });
              this.reportDatas.sort((a, b) => {
                if (a.departmanAdi < b.departmanAdi) return -1;
                if (a.departmanAdi > b.departmanAdi) return 0;
              });
            }
          });
        } else if (this.selectedReportId == 6) {
          //İçeridekiler Raporu
          this.reportHeaders = [];
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.InsidesReportHeaders.registrationNumber"
            )
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.InsidesReportHeaders.nameSurname")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.InsidesReportHeaders.entryTime")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.InsidesReportHeaders.entryPoint")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.InsidesReportHeaders.status")
          );
          var keys = ["sicilNo", "name", "entryDate", "entryPoint", "status"];
          this.reportDatas = [];
          this.reportResult.forEach(item => {
            if (item.veriler.length > 0) {
              this.reportDatas.push({
                departmanAdi: item.departmanAdi,
                keys: keys,
                veriler: item.veriler
              });
              this.reportDatas.sort((a, b) => {
                if (a.departmanAdi < b.departmanAdi) return -1;
                if (a.departmanAdi > b.departmanAdi) return 0;
              });
            }
          });
        } else if (this.selectedReportId == 7) {
          //Dışarıdakiler Raporu
          this.reportHeaders = [];
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.OutsidesReportHeaders.registrationNumber"
            )
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.OutsidesReportHeaders.nameSurname")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.OutsidesReportHeaders.exitTime")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.OutsidesReportHeaders.exitPoint")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.OutsidesReportHeaders.status")
          );
          var keys = ["sicilNo", "name", "exitDate", "exitPoint", "status"];
          this.reportDatas = [];
          this.reportResult.forEach(item => {
            if (item.veriler.length > 0) {
              this.reportDatas.push({
                departmanAdi: item.departmanAdi,
                keys: keys,
                veriler: item.veriler
              });
              this.reportDatas.sort((a, b) => {
                if (a.departmanAdi < b.departmanAdi) return -1;
                if (a.departmanAdi > b.departmanAdi) return 0;
              });
            }
          });
        } else if (this.selectedReportId == 8) {
          //Ziyaretçiler Raporu
          this.reportHeaders = [];
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.VisitorsReportHeaders.citizenshipNumber"
            )
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.VisitorsReportHeaders.nameSurname")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.VisitorsReportHeaders.mobilePhone")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.VisitorsReportHeaders.where")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.VisitorsReportHeaders.departmentName")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.VisitorsReportHeaders.reasonForVisit")
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.VisitorsReportHeaders.visitedEmployeeInformation"
            )
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.VisitorsReportHeaders.cardIssueTime")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.VisitorsReportHeaders.entryTime")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.VisitorsReportHeaders.exitTime")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.VisitorsReportHeaders.cardName")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.VisitorsReportHeaders.description")
          );
          var keys = [
            "identityNo",
            "name",
            "mobilePhone",
            "toWho",
            "departmentName",
            "comingReason",
            "employeeInfo",
            "entryDate",
            "entryLogDate",
            "exitDate",
            "cardInfo",
            "description"
          ];
          this.reportDatas = [];
          this.reportResult.forEach(item => {
            if (item.veriler.length > 0) {
              this.reportDatas.push({
                departmanAdi: item.departmanAdi,
                keys: keys,
                veriler: item.veriler
              });
              this.reportDatas.sort((a, b) => {
                if (a.departmanAdi < b.departmanAdi) return -1;
                if (a.departmanAdi > b.departmanAdi) return 0;
              });
            }
          });
        } else if (this.selectedReportId == 9) {
          //İçerideki Ziyaretçiler Raporu
          this.reportHeaders = [];
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.InsideVisitorsReportHeader.citizenshipNumber"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.InsideVisitorsReportHeader.nameSurname"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.InsideVisitorsReportHeader.mobilePhone"
            )
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.InsideVisitorsReportHeader.where")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.InsideVisitorsReportHeader.departmentName")
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.InsideVisitorsReportHeader.reasonForVisit"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.InsideVisitorsReportHeader.visitedEmployeeInformation"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.InsideVisitorsReportHeader.cardIssueTime"
            )
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.InsideVisitorsReportHeader.entryTime")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.InsideVisitorsReportHeader.cardName")
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.InsideVisitorsReportHeader.description"
            )
          );
          var keys = [
            "identityNo",
            "name",
            "mobilePhone",
            "toWho",
            "departmentName",
            "comingReason",
            "employeeInfo",
            "entryDate",
            "entryLogDate",
            "cardInfo",
            "description"
          ];
          this.reportDatas = [];
          this.reportResult.forEach(item => {
            if (item.veriler.length > 0) {
              this.reportDatas.push({
                departmanAdi: item.departmanAdi,
                keys: keys,
                veriler: item.veriler
              });
              this.reportDatas.sort((a, b) => {
                if (a.departmanAdi < b.departmanAdi) return -1;
                if (a.departmanAdi > b.departmanAdi) return 0;
              });
            }
          });
        } else if (this.selectedReportId == 10) {
          //Süre Bazlı Çalışma Raporu
          this.reportHeaders = [];
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.TimeBasedWorkReportHeaders.registrationNumber"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.TimeBasedWorkReportHeaders.nameSurname"
            )
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.TimeBasedWorkReportHeaders.startDate")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.TimeBasedWorkReportHeaders.endDate")
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.TimeBasedWorkReportHeaders.totalWorkedTime"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.TimeBasedWorkReportHeaders.difference"
            )
          );
          var keys = [
            "sicilNo",
            "adSoyad",
            "startDate",
            "endDate",
            "total",
            "difference"
          ];
          this.reportDatas = [];
          this.reportResult.forEach(item => {
            if (item.veriler.length > 0) {
              this.reportDatas.push({
                departmanAdi: item.departmanAdi,
                keys: keys,
                veriler: item.veriler
              });
              this.reportDatas.sort((a, b) => {
                if (a.departmanAdi < b.departmanAdi) return -1;
                if (a.departmanAdi > b.departmanAdi) return 0;
              });
            }
          });
        } else if (this.selectedReportId == 11) {
          //İlk Giriş Son Çıkış Raporu
          this.reportHeaders = [];
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.FirstInLastOutReportHeaders.citizenshipNumber"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.FirstInLastOutReportHeaders.registrationNumber"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.FirstInLastOutReportHeaders.nameSurname"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.FirstInLastOutReportHeaders.department"
            )
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.FirstInLastOutReportHeaders.title")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.FirstInLastOutReportHeaders.status1")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.FirstInLastOutReportHeaders.workPlace")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.FirstInLastOutReportHeaders.workPlan")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.FirstInLastOutReportHeaders.date")
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.FirstInLastOutReportHeaders.firstEntry"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.FirstInLastOutReportHeaders.entryReader"
            )
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.FirstInLastOutReportHeaders.lastExit")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.FirstInLastOutReportHeaders.exitReader")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.FirstInLastOutReportHeaders.status")
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.FirstInLastOutReportHeaders.earlyEntry"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.FirstInLastOutReportHeaders.lateEntry"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.FirstInLastOutReportHeaders.earlyExit"
            )
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.FirstInLastOutReportHeaders.lateExit")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.FirstInLastOutReportHeaders.total")
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.FirstInLastOutReportHeaders.missingHour"
            )
          );
          var keys = [
            "tcNo",
            "sicilNo",
            "adSoyad",
            "departman",
            "unvan",
            "statu",
            "gorevYeri",
            "calismaGrubu",
            "tarih",
            "ilkG",
            "girisOkuyucu",
            "sonC",
            "cikisOkuyucu",
            "durum",
            "erkenG",
            "gecG",
            "erkenC",
            "gecC",
            "total",
            "fark"
          ];
          this.reportDatas = [];
          this.reportResult.forEach(item => {
            if (item.veriler.length > 0) {
              this.reportDatas.push({
                departmanAdi: item.departmanAdi,
                keys: keys,
                veriler: item.veriler
              });
              this.reportDatas.sort((a, b) => {
                if (a.departmanAdi < b.departmanAdi) return -1;
                if (a.departmanAdi > b.departmanAdi) return 0;
              });
            }
          });
        } else if (this.selectedReportId == 12) {
          //İzinliler Raporu
          this.reportHeaders = [];
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.AllowenceReportHeaders.registrationNumber"
            )
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.AllowenceReportHeaders.nameSurname")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.AllowenceReportHeaders.startDate")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.AllowenceReportHeaders.endDate")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.AllowenceReportHeaders.allowenceName")
          );
          var keys = [
            "sicilNo",
            "name",
            "startDate",
            "endDate",
            "allowenceName"
          ];
          this.reportDatas = [];
          this.reportResult.forEach(item => {
            if (item.veriler.length > 0) {
              this.reportDatas.push({
                departmanAdi: item.departmanAdi,
                keys: keys,
                veriler: item.veriler
              });
              this.reportDatas.sort((a, b) => {
                if (a.departmanAdi < b.departmanAdi) return -1;
                if (a.departmanAdi > b.departmanAdi) return 0;
              });
            }
          });
        } else if (this.selectedReportId == 13) {
          //Çalışma Özeti Raporu
          this.reportHeaders = [];
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.WorkSummaryReportHeaders.registrationNumber"
            )
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.WorkSummaryReportHeaders.nameSurname")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.WorkSummaryReportHeaders.jobDays")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.WorkSummaryReportHeaders.workDays")
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.WorkSummaryReportHeaders.publicHoliday"
            )
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.WorkSummaryReportHeaders.allowence")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.WorkSummaryReportHeaders.absentee")
          );
          var keys = [
            "sicilNo",
            "name",
            "planWorkDay",
            "workDay",
            "publicHolidayOrAdministrativeLeave",
            "allowenceUsed",
            "absentee"
          ];
          this.reportDatas = [];
          this.reportResult.forEach(item => {
            if (item.veriler.length > 0) {
              this.reportDatas.push({
                departmanAdi: item.departmanAdi,
                keys: keys,
                veriler: item.veriler
              });
              this.reportDatas.sort((a, b) => {
                if (a.departmanAdi < b.departmanAdi) return -1;
                if (a.departmanAdi > b.departmanAdi) return 0;
              });
            }
          });
        } else if (this.selectedReportId == 14) {
          //Departman Bazlı Sayı Raporu
          this.reportHeaders = [];
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.CompanyEmployeesStatusReportHeaders.unitName"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.CompanyEmployeesStatusReportHeaders.employeeCount"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.CompanyEmployeesStatusReportHeaders.annualPermit"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.CompanyEmployeesStatusReportHeaders.report"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.CompanyEmployeesStatusReportHeaders.administrativeLeave"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.CompanyEmployeesStatusReportHeaders.freePermission"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.CompanyEmployeesStatusReportHeaders.missioned"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.CompanyEmployeesStatusReportHeaders.nonComers"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.CompanyEmployeesStatusReportHeaders.todayComers"
            )
          );
          var keys = [
            "unitName",
            "employeesInDepartments",
            "annualPermit",
            "report",
            "administrativeLeave",
            "freePermission",
            "missioned",
            "nonComers",
            "todayComers"
          ];
          this.reportDatas = [];
          this.reportResult.forEach(item => {
            if (item.veriler.length > 0) {
              this.reportDatas.push({
                departmanAdi: item.departmanAdi,
                keys: keys,
                veriler: item.veriler
              });
              this.reportDatas.sort((a, b) => {
                if (a.departmanAdi < b.departmanAdi) return -1;
                if (a.departmanAdi > b.departmanAdi) return 0;
              });
            }
          });
        } else if (this.selectedReportId == 15) {
          //Müdürlük Bazlı Sayı Raporu
          this.reportHeaders = [];
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.CompanyEmployeesStatusReportHeaders.unitName"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.CompanyEmployeesStatusReportHeaders.employeeCount"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.CompanyEmployeesStatusReportHeaders.annualPermit"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.CompanyEmployeesStatusReportHeaders.report"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.CompanyEmployeesStatusReportHeaders.administrativeLeave"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.CompanyEmployeesStatusReportHeaders.freePermission"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.CompanyEmployeesStatusReportHeaders.missioned"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.CompanyEmployeesStatusReportHeaders.nonComers"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.CompanyEmployeesStatusReportHeaders.todayComers"
            )
          );
          var keys = [
            "unitName",
            "employeesInDepartments",
            "annualPermit",
            "report",
            "administrativeLeave",
            "freePermission",
            "missioned",
            "nonComers",
            "todayComers"
          ];
          this.reportDatas = [];
          this.reportResult.forEach(item => {
            if (item.veriler.length > 0) {
              this.reportDatas.push({
                departmanAdi: item.departmanAdi,
                keys: keys,
                veriler: item.veriler
              });
            }
          });
        } else if (this.selectedReportId == 16) {
          //Puantaj Raporu
          var keys = [
            "sicilNo",
            "name",
            "shortCode1",
            "shortCode2",
            "shortCode3",
            "shortCode4",
            "shortCode5",
            "shortCode6",
            "shortCode7",
            "shortCode8",
            "shortCode9",
            "shortCode10",
            "shortCode11",
            "shortCode12",
            "shortCode13",
            "shortCode14",
            "shortCode15",
            "shortCode16",
            "shortCode17",
            "shortCode18",
            "shortCode19",
            "shortCode20",
            "shortCode21",
            "shortCode22",
            "shortCode23",
            "shortCode24",
            "shortCode25",
            "shortCode26",
            "shortCode27",
            "shortCode28",
            "shortCode29",
            "shortCode30",
            "shortCode31"
          ];
          this.reportDatas = [];
          this.reportResult.forEach(item => {
            if (item.veriler.length > 0) {
              this.reportDatas.push({
                departmanAdi: item.departmanAdi,
                keys: keys,
                veriler: item.veriler
              });
            }
          });
        } else if (this.selectedReportId == 17) {
          //Detaylı Puantaj Raporu
          var keys = [
            "sicilNo",
            "adSoyad",
            "realWorkDay",
            "d1",
            "d2",
            "d3",
            "d4",
            "d5",
            "d6",
            "d7",
            "d8",
            "d9",
            "d10",
            "d11",
            "d12",
            "d13",
            "d14",
            "d15",
            "d16",
            "d17",
            "d18",
            "d19",
            "d20",
            "d21",
            "d22",
            "d23",
            "d24",
            "d25",
            "d26",
            "d27",
            "d28",
            "d29",
            "d30",
            "d31"
          ];
          this.reportDatas = [];
          this.reportResult.forEach(item => {
            if (item.veriler.length > 0) {
              this.reportDatas.push({
                departmanAdi: item.departmanAdi,
                keys: keys,
                veriler: item.veriler
              });
            }
          });
        } else if (this.selectedReportId == 18) {
          //Yemekhane Yüklemeler Raporu
          this.reportHeaders = [];
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.FoodCreditReportHeaders.registrationNumber"
            )
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.FoodCreditReportHeaders.nameSurname")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.FoodCreditReportHeaders.date")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.FoodCreditReportHeaders.debit")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.FoodCreditReportHeaders.creditType")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.FoodCreditReportHeaders.userName")
          );
          var keys = [
            "sicilNo",
            "name",
            "date",
            "credit",
            "creditType",
            "userName"
          ];
          this.reportDatas = [];
          this.reportResult.forEach(item => {
            if (item.veriler.length > 0) {
              var veriler2 = [];
              item.veriler.forEach(veri => {
                var type = "";
                if (veri.creditType == 2) {
                  type = this.$ml.get("general.balance");
                } else if (veri.creditType == 1) {
                  type = this.$ml.get("general.credit");
                }
                veriler2.push({
                  sicilNo: veri.sicilNo,
                  name: veri.name,
                  date: veri.date,
                  credit: veri.credit,
                  creditType: type,
                  userName: veri.userName
                });
              });
              this.reportDatas.push({
                departmanAdi: item.departmanAdi,
                keys: keys,
                veriler: veriler2
              });
            }
          });
        } else if (this.selectedReportId == 25) {
          //Yemekhane İcmal Raporu
          this.reportHeaders = [];
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.FoodSummaryReportHeaders.departmentName"
            )
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.FoodSummaryReportHeaders.total")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.FoodSummaryReportHeaders.debit")
          );
          var keys = ["name", "count", "price"];
          this.reportDatas = [];
          this.reportResult.forEach(item => {
            if (item.veriler.length > 0) {
              this.reportDatas.push({
                departmanAdi: item.departmanAdi,
                keys: keys,
                veriler: item.veriler
              });
            }
          });
        } else if (this.selectedReportId == 19) {
          //Giriş Çıkış Raporu
          this.reportHeaders = [];
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.InOutReportHeaders.registrationNumber"
            )
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.InOutReportHeaders.nameSurname")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.InOutReportHeaders.title")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.InOutReportHeaders.workPlace")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.InOutReportHeaders.departmentName")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.InOutReportHeaders.location")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.InOutReportHeaders.date")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.InOutReportHeaders.readerName")
          );
          var keys = [
            "sicilNo",
            "name",
            "title",
            "workPlace",
            "departmentName",
            "location",
            "date",
            "reader"
          ];
          this.reportDatas = [];
          this.reportResult.forEach(item => {
            if (item.veriler.length > 0) {
              this.reportDatas.push({
                departmanAdi: item.departmanAdi,
                keys: keys,
                veriler: item.veriler
              });
            }
          });
        } else if (this.selectedReportId == 20) {
          //Kapı Bazlı Son Hareket Raporu
          this.reportHeaders = [];
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DoorBasedLastMovementReportHeaders.registrationNumber"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DoorBasedLastMovementReportHeaders.nameSurname"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DoorBasedLastMovementReportHeaders.title"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DoorBasedLastMovementReportHeaders.departmentName"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DoorBasedLastMovementReportHeaders.date"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DoorBasedLastMovementReportHeaders.readerName"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DoorBasedLastMovementReportHeaders.doorStatus"
            )
          );
          var keys = [
            "sicilNo",
            "name",
            "title",
            "departmentName",
            "date",
            "reader",
            "doorStatus"
          ];
          this.reportDatas = [];
          this.reportResult.forEach(item => {
            if (item.veriler.length > 0) {
              this.reportDatas.push({
                departmanAdi: item.departmanAdi,
                keys: keys,
                veriler: item.veriler
              });
            }
          });
        } else if (this.selectedReportId == 21) {
          //Kapı Bazlı Yetki Raporu
          this.reportHeaders = [];
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DoorsAuthorizationReportHeaders.registrationNumber"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DoorsAuthorizationReportHeaders.nameSurname"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DoorsAuthorizationReportHeaders.title"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DoorsAuthorizationReportHeaders.departmentName"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DoorsAuthorizationReportHeaders.accessGroup"
            )
          );
          var keys = [
            "sicilNo",
            "name",
            "title",
            "departmentName",
            "accessGroup"
          ];
          this.reportDatas = [];
          this.reportResult.forEach(item => {
            if (item.veriler.length > 0) {
              this.reportDatas.push({
                departmanAdi: item.departmanAdi,
                keys: keys,
                veriler: item.veriler
              });
            }
          });
        } else if (this.selectedReportId == 22) {
          //Yurtta Kalanlar Raporu
          this.reportHeaders = [];
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DormitoryInformationReportHeaders.registrationNumber"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DormitoryInformationReportHeaders.nameSurname"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DormitoryInformationReportHeaders.departmentName"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DormitoryInformationReportHeaders.isSmsSend"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DormitoryInformationReportHeaders.motherName"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DormitoryInformationReportHeaders.fatherName"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DormitoryInformationReportHeaders.smsPhone"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DormitoryInformationReportHeaders.validityDate"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DormitoryInformationReportHeaders.areaName"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DormitoryInformationReportHeaders.floorName"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DormitoryInformationReportHeaders.roomName"
            )
          );
          var keys = [
            "sicilNo",
            "name",
            "departmentName",
            "isSmsSend",
            "motherName",
            "fatherName",
            "smsPhone",
            "validityDate",
            "areaName",
            "floorName",
            "roomName"
          ];
          this.reportDatas = [];
          this.reportResult.forEach(item => {
            if (item.veriler.length > 0) {
              this.reportDatas.push({
                departmanAdi: item.departmanAdi,
                keys: keys,
                veriler: item.veriler
              });
            }
          });
        } else if (this.selectedReportId == 23) {
          //Yurt İçerideki Öğrenciler Raporu
          this.reportHeaders = [];
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DormitoryInsidesReportHeaders.registrationNumber"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DormitoryInsidesReportHeaders.nameSurname"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DormitoryInsidesReportHeaders.departmentName"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DormitoryInsidesReportHeaders.lastMovementDate"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DormitoryInsidesReportHeaders.lastMovementReader"
            )
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.DormitoryInsidesReportHeaders.status")
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DormitoryInsidesReportHeaders.isSmsSend"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DormitoryInsidesReportHeaders.motherName"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DormitoryInsidesReportHeaders.fatherName"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DormitoryInsidesReportHeaders.smsPhone"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DormitoryInsidesReportHeaders.validityDate"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DormitoryInsidesReportHeaders.areaName"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DormitoryInsidesReportHeaders.floorName"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DormitoryInsidesReportHeaders.roomName"
            )
          );
          var keys = [
            "sicilNo",
            "name",
            "departmentName",
            "exitDate",
            "exitPoint",
            "status",
            "isSmsSend",
            "motherName",
            "fatherName",
            "smsPhone",
            "validityDate",
            "areaName",
            "floorName",
            "roomName"
          ];
          this.reportDatas = [];
          this.reportResult.forEach(item => {
            if (item.veriler.length > 0) {
              this.reportDatas.push({
                departmanAdi: item.departmanAdi,
                keys: keys,
                veriler: item.veriler
              });
            }
          });
        } else if (this.selectedReportId == 24) {
          //Yurt Dışarıdaki Öğrenciler Raporu
          this.reportHeaders = [];
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DormitoryOutsidesReportHeaders.registrationNumber"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DormitoryOutsidesReportHeaders.nameSurname"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DormitoryOutsidesReportHeaders.departmentName"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DormitoryOutsidesReportHeaders.lastMovementDate"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DormitoryOutsidesReportHeaders.lastMovementReader"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DormitoryOutsidesReportHeaders.status"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DormitoryOutsidesReportHeaders.isSmsSend"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DormitoryOutsidesReportHeaders.motherName"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DormitoryOutsidesReportHeaders.fatherName"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DormitoryOutsidesReportHeaders.smsPhone"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DormitoryOutsidesReportHeaders.validityDate"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DormitoryOutsidesReportHeaders.areaName"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DormitoryOutsidesReportHeaders.floorName"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DormitoryOutsidesReportHeaders.roomName"
            )
          );
          var keys = [
            "sicilNo",
            "name",
            "departmentName",
            "exitDate",
            "exitPoint",
            "status",
            "isSmsSend",
            "motherName",
            "fatherName",
            "smsPhone",
            "validityDate",
            "areaName",
            "floorName",
            "roomName"
          ];
          this.reportDatas = [];
          this.reportResult.forEach(item => {
            if (item.veriler.length > 0) {
              this.reportDatas.push({
                departmanAdi: item.departmanAdi,
                keys: keys,
                veriler: item.veriler
              });
            }
          });
        } else if (this.selectedReportId == 26) {
          //Puantaj Şablon-1 Raporu
          this.reportHeaders = this.reportResult[0].headers;
          var keys = [
            "sicilNo",
            "name",
            "title",
            "department",
            "date",
            "payrollName",
            "entry",
            "exit",
            "calculatedOvertime",
            "confirmedOvertime",
            "Item0",
            "Item1",
            "Item2",
            "Item3",
            "Item4",
            "Item5",
            "Item6",
            "Item7",
            "Item8",
            "Item9",
            "Item10",
            "Item11"
          ];
          this.reportDatas = [];
          this.reportResult.forEach(item => {
            if (item.veriler.length > 0) {
              this.reportDatas.push({
                departmanAdi: item.departmanAdi,
                keys: item.keys,
                veriler: item.veriler
              });
            }
          });
        } else if (this.selectedReportId == 27) {
          //Aylık Puantaj Raporu
          this.reportHeaders = this.reportResult[0].headers;
          this.reportDatas = [];
          this.reportResult.forEach(item => {
            if (item.veriler.length > 0) {
              this.reportDatas.push({
                departmanAdi: item.departmanAdi,
                keys: item.keys,
                veriler: item.veriler
              });
            }
          });
        } else if (this.selectedReportId == 28) {
          //Aylık Maaş Raporu
          this.reportHeaders = this.reportResult[0].headers;
          this.reportDatas = [];
          this.reportResult.forEach(item => {
            if (item.veriler.length > 0) {
              this.reportDatas.push({
                departmanAdi: item.departmanAdi,
                keys: item.keys,
                veriler: item.veriler
              });
            }
          });
        } else if (this.selectedReportId == 29) {
          // Haftalık Puantaj Raporu
          this.reportHeaders = [];
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.WeeklyPayrollReportHeaders.registrationNumber"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.WeeklyPayrollReportHeaders.nameSurname"
            )
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.WeeklyPayrollReportHeaders.title")
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.WeeklyPayrollReportHeaders.departmentName"
            )
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.WeeklyPayrollReportHeaders.workTime")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.WeeklyPayrollReportHeaders.overTime")
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.WeeklyPayrollReportHeaders.nightWorkTime"
            )
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.WeeklyPayrollReportHeaders.status")
          );
          var keys = [
            "sicilNo",
            "name",
            "title",
            "departmentName",
            "workTime",
            "overTime",
            "nightWorkTime",
            "status"
          ];
          this.reportDatas = [];
          this.reportResult.forEach(item => {
            if (item.veriler.length > 0) {
              this.reportDatas.push({
                departmanAdi: item.departmanAdi,
                keys: keys,
                veriler: item.veriler
              });
            }
          });
        } else if (this.selectedReportId == 30) {
          //İki Tarih Arası Departman Bazlı Sayı Raporu
          this.reportHeaders = [];
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DepartmentSummaryReportHeaders.unitName"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DepartmentSummaryReportHeaders.employeeCount"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DepartmentSummaryReportHeaders.annualPermit"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DepartmentSummaryReportHeaders.report"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DepartmentSummaryReportHeaders.administrativeLeave"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DepartmentSummaryReportHeaders.freePermission"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DepartmentSummaryReportHeaders.missioned"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DepartmentSummaryReportHeaders.nonComers"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DepartmentSummaryReportHeaders.todayComers"
            )
          );
          var keys = [
            "unitName",
            "employeesInDepartments",
            "annualPermit",
            "report",
            "administrativeLeave",
            "freePermission",
            "missioned",
            "nonComers",
            "todayComers"
          ];
          this.reportDatas = [];
          this.reportResult.forEach(item => {
            if (item.veriler.length > 0) {
              this.reportDatas.push({
                departmanAdi: item.departmanAdi,
                keys: keys,
                veriler: item.veriler
              });
              this.reportDatas.sort((a, b) => {
                if (a.departmanAdi < b.departmanAdi) return -1;
                if (a.departmanAdi > b.departmanAdi) return 0;
              });
            }
          });
        } else if (this.selectedReportId == 31) {
          //Fotoğraflı Hareket Raporu
          this.reportHeaders = [];
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.EntryExitSnapshotReportHeaders.registrationNumber"
            )
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.EntryExitSnapshotReportHeaders.nameSurname"
            )
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.EntryExitSnapshotReportHeaders.title")
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.EntryExitSnapshotReportHeaders.departmentName"
            )
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.EntryExitSnapshotReportHeaders.date")
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.EntryExitSnapshotReportHeaders.reader"
            )
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.EntryExitSnapshotReportHeaders.photo")
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.EntryExitSnapshotReportHeaders.snapshot"
            )
          );
          var keys = [
            "sicilNo",
            "name",
            "title",
            "departmentName",
            "date",
            "reader",
            "photo",
            "snapshot"
          ];
          this.reportDatas = [];
          this.reportResult.forEach(item => {
            if (item.veriler.length > 0) {
              this.reportDatas.push({
                departmanAdi: item.departmanAdi,
                keys: keys,
                veriler: item.veriler
              });
            }
          });
        } else if (this.selectedReportId == 32) {
          //Satış Raporu
          this.reportHeaders = [];
          this.reportHeaders.push(
            this.$ml.get("reports.reports.SaleReportHeaders.registrationNumber")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.SaleReportHeaders.nameSurname")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.SaleReportHeaders.price")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.SaleReportHeaders.date")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.SaleReportHeaders.user")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.SaleReportHeaders.isRefund")
          );
          var keys = ["sicilNo", "name", "price", "date", "user", "isRefund"];
          this.reportDatas = [];
          this.reportResult.forEach(item => {
            if (item.veriler.length > 0) {
              this.reportDatas.push({
                departmanAdi: item.departmanAdi,
                keys: keys,
                veriler: item.veriler
              });
            }
          });
        } else if (this.selectedReportId == 33) {
          //Detaylı Ziyaretçi Hareket Raporu
          this.reportHeaders = [];
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DetailedVisitorReportHeaders.citizenshipNumber"
            )
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.DetailedVisitorReportHeaders.nameSurname")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.DetailedVisitorReportHeaders.mobilePhone")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.DetailedVisitorReportHeaders.where")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.DetailedVisitorReportHeaders.departmentName")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.DetailedVisitorReportHeaders.reasonForVisit")
          );
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DetailedVisitorReportHeaders.visitedEmployeeInformation"
            )
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.DetailedVisitorReportHeaders.cardIssueTime")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.DetailedVisitorReportHeaders.entryTime")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.DetailedVisitorReportHeaders.exitTime")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.DetailedVisitorReportHeaders.cardName")
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.DetailedVisitorReportHeaders.description")
          );
          var keys = [
            "identityNo",
            "name",
            "mobilePhone",
            "toWho",
            "departmentName",
            "comingReason",
            "employeeInfo",
            "entryDate",
            "entryLogDate",
            "exitDate",
            "cardInfo",
            "description"
          ];
          this.reportDatas = [];
          var movementsMaxLength = 0;
          this.reportResult.forEach(item => {
            if (item.veriler.length > 0) {
              this.reportDatas.push({
                departmanAdi: item.departmanAdi,
                keys: keys,
                veriler: item.veriler
              });
              item.veriler.forEach(iVeri => {
                if (iVeri.movements.length > movementsMaxLength) {
                  movementsMaxLength = iVeri.movements.length;
                }
              });
              for (let index = 0; index < movementsMaxLength; index++) {
                this.reportHeaders.push((index + 1) + ". Hareket");
              }
              this.reportDatas.sort((a, b) => {
                if (a.departmanAdi < b.departmanAdi) return -1;
                if (a.departmanAdi > b.departmanAdi) return 0;
              });
            }
          });
        } else if (this.selectedReportId == 34) {
          //Departman Bazlı Ziyaretçi Raporu
          this.reportHeaders = [];
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.DepartmentBasedVisitorReportHeaders.departmentName"
            )
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.DepartmentBasedVisitorReportHeaders.total")
          );
          var keys = [
            "departmentName",
            "total"
          ];
          this.reportDatas = [];
          var movementsMaxLength = 0;
          this.reportResult.forEach(item => {
            if (item.veriler.length > 0) {
              this.reportDatas.push({
                departmanAdi: item.departmanAdi,
                keys: keys,
                veriler: item.veriler
              });
            }
          });
        } else if (this.selectedReportId == 35) {
          //Vardiya Raporu
          this.reportHeaders = [];
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.ShiftReportHeaders.departmentName"
            )
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.ShiftReportHeaders.total")
          );
          var keys = [
            "departmentName",
            "total"
          ];
          this.reportDatas = [];
          var movementsMaxLength = 0;
          this.reportResult.forEach(item => {
            if (item.veriler.length > 0) {
              this.reportDatas.push({
                departmanAdi: item.departmanAdi,
                keys: keys,
                veriler: item.veriler
              });
            }
          });
        } else if (this.selectedReportId == 36) {
          //Dikey İlk Giriş Son Çıkış Raporu
          this.reportHeaders = [];
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.VerticalFirstInLastOutReportHeaders.departmentName"
            )
          );
          this.reportHeaders.push(
            this.$ml.get("reports.reports.VerticalFirstInLastOutReportHeaders.total")
          );
          var keys = [
            "departmentName",
            "total"
          ];
          this.reportDatas = [];
          var movementsMaxLength = 0;
          this.reportResult.forEach(item => {
            if (item.veriler.length > 0) {
              this.reportDatas.push({
                departmanAdi: item.departmanAdi,
                keys: keys,
                veriler: item.veriler
              });
            }
          });
        } else {
          alertify.warning(this.$ml.get("reports.selectedReportIsUnavailable"));
        }
      } else {
        this.reportHeaders = null;
        this.reportDatas = null;
      }
    },
    async getReportDetails() {
      if (this.selectedReportId == 0) {
        alertify.warning(this.$ml.get("alerts.selectedReportNotBlank"));
        return;
      }
      if (
        this.startDate == null ||
        this.endDate == null ||
        this.startDate > this.endDate
      ) {
        alertify.warning(this.$ml.get("alerts.invalidDate"));
        return;
      }
      try {
        this.activeScreen = 3;
        this.isLoading = true;
        let empIds = await this.getSelectedEmployeeList();
        let reportEndPoint = this.selectedReportEndPoint;
        let startDate = this.startDate;
        let endDate = this.endDate;
        await this.getCheckReaders();
        let devices = this.selectedDevices;
        let allowenceIds = [];
        let visitorGroupIds = [];
        var reportOption = {
          empIds: empIds,
          startDate: startDate,
          endDate: endDate,
          deviceIds: devices
        };
        if (this.selectedReportId == 6 || this.selectedReportId == 7) {
          reportOption = {
            empIds: empIds,
            deviceIds: devices,
            startDate: startDate
          };
        }
        if (this.selectedReportId == 8 || this.selectedReportId == 33) {
          await this.getCheckVisitorGroups();
          visitorGroupIds = this.selectedVisitorGroups;
          reportOption = {
            startDate: startDate,
            endDate: endDate,
            visitorGroupIds: visitorGroupIds
          };
        }
        if (this.selectedReportId == 9) {
          reportOption = {
            startDate: startDate,
            endDate: endDate
          };
        }
        if (this.selectedReportId == 10) {
          reportOption = {
            empIds: empIds,
            startDate: startDate,
            endDate: endDate,
            time: this.reportOptions.time,
            isUpperFromTime: this.reportOptions.isUpperFromTime,
            showNonComers: this.reportOptions.showNonComers
          };
        }
        if (this.selectedReportId == 11) {
          reportOption = {
            empIds: empIds,
            startDate: startDate,
            endDate: endDate,
            showAllowed: this.reportOptions.showAllowed,
            showNonComers: this.reportOptions.showNonComers,
            deviceIds: devices
          };
        }
        if (this.selectedReportId == 12) {
          await this.getCheckAllowences();
          allowenceIds = this.selectedAllowences;
          reportOption = {
            empIds: empIds,
            startDate: startDate,
            endDate: endDate,
            allowenceIds: allowenceIds
          };
        }
        if (
          this.selectedReportId == 13 ||
          this.selectedReportId == 16 ||
          this.selectedReportId == 17 ||
          this.selectedReportId == 18 ||
          this.selectedReportId == 26 ||
          this.selectedReportId == 29 ||
          this.selectedReportId == 32
        ) {
          reportOption = {
            empIds: empIds,
            startDate: startDate,
            endDate: endDate
          };
        }
        if (this.selectedReportId == 20 || this.selectedReportId == 21) {
          reportOption = {
            empIds: empIds,
            deviceIds: devices
          };
        }
        if (
          this.selectedReportId == 22 ||
          this.selectedReportId == 23 ||
          this.selectedReportId == 24
        ) {
          reportOption = {
            empIds: empIds
          };
        }
        if (this.selectedReportId == 14 || this.selectedReportId == 15) {
          await this.getCheckDepartmentList();
          reportOption = {
            empIds: this.filters.departments,
            startDate: startDate
          };
        }
        if (this.selectedReportId == 25 || this.selectedReportId == 30) {
          await this.getCheckDepartmentList();
          reportOption = {
            empIds: this.filters.departments,
            startDate: startDate,
            endDate: endDate
          };
        }
        if (this.selectedReportId == 1) {
          reportOption = {
            empIds: empIds,
            startDate: startDate,
            endDate: endDate,
            deviceIds: devices,
            showAllowed: this.reportOptions.showAllowed,
            showLateComers: this.reportOptions.showLateComers
          };
        }
        const response = await this.$axios
          .post("/Reports/" + reportEndPoint, reportOption)
          .then(response => {
            this.reportResult = response.data.datas;
            if (this.selectedReportId == 16 || this.selectedReportId == 17) {
              this.reportHeaders = response.data.headers;
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        await this.reportSetting();
        this.reportName =
          this.selectedReportName +
          " (" +
          this.toDateFormat(this.startDate, "gg.aa.yyyy ss:dd") +
          " - " +
          this.toDateFormat(this.endDate, "gg.aa.yyyy ss:dd") +
          ")";
        if (this.selectedReportId == 14) {
          this.reportName =
            this.selectedReportName +
            " (" +
            this.toDateFormat(this.startDate, "gg.aa.yyyy") +
            ")";
        }
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoading = false;
      }
    },
    async getEmployees() {
      try {
        this.isLoadingEmployee = true;
        await this.getCheckDepartmentList();
        const employees = [];
        let filters2 = this.filters;
        const response = await this.$axios
          .post("/Employees/getByFilter", {
            nameOrCardNumber: filters2.nameOrCardNumber,
            sicilOrTerminalNo: filters2.sicilOrTerminalNo,
            departments: filters2.departments,
            accessGroup: filters2.accessGroup,
            identityNo: filters2.identityNo,
            documentNoOrMail: filters2.documentNoOrMail,
            foodGroup: filters2.foodGroup,
            workGroupId: filters2.workGroupId,
            title: filters2.title,
            stateId: filters2.stateId,
            statuId: filters2.statuId,
            plateNo: filters2.plateNo,
            extraField1key: filters2.extraField1key,
            extraField1value: filters2.extraField1value,
            extraField2key: filters2.extraField2key,
            extraField2value: filters2.extraField2value,
            extraField3key: filters2.extraField3key,
            extraField3value: filters2.extraField3value,
            extraField4key: filters2.extraField4key,
            extraField4value: filters2.extraField4value,
            isVisitor: filters2.isVisitor,
            isActive: filters2.isActive
          })
          .then(response => {
            response.data.forEach(doc => {
              employees.push({
                id: doc.id,
                name: doc.name,
                sicilNo: doc.sicilNo,
                title: doc.title,
                check: true
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.employees = employees;
        this.isLoadingEmployee = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoadingEmployee = false;
      }
    },
    checkAllReaders() {
      this.isCheckReaders = !this.isCheckReaders;
      let aList = this.readers;
      aList.forEach(doc => {
        if (doc.check == !this.isCheckReaders) {
          doc.check = this.isCheckReaders;
        }
      });
    },
    async getCheckReaders() {
      this.selectedDevices = [];
      await this.readers.forEach(doc => {
        if (doc.check == true) {
          this.selectedDevices.push(doc.readerId);
        }
      });
    },
    async getReaders() {
      try {
        const readers = [];
        const response = await this.$axios
          .get("/Terminal/GetReaders")
          .then(response => {
            if (response.status == 200) {
              response.data.forEach(doc => {
                var isCheckNew = true;
                if (doc.doorType != 1) {
                  isCheckNew == false;
                }
                if (
                  doc.doorType == 0 ||
                  doc.doorType == 1 ||
                  doc.doorType == 2 ||
                  doc.doorType == 3 ||
                  doc.doorType == 5
                ) {
                  readers.push({
                    readerNo: doc.readerNo,
                    readerId: doc.readerId,
                    terminalId: doc.terminalId,
                    terminalNo: doc.terminalNo,
                    ipAddress: doc.ipAddress,
                    isActive: doc.isActive,
                    doorType: doc.doorType,
                    name: doc.name,
                    check: isCheckNew
                  });
                }
              });
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
              if (error.response.status == 500) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.readers = readers;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası : " + error.message);
      }
    },
    checkAllAllowence() {
      this.isCheckAllowences = !this.isCheckAllowences;
      let aList = this.allowences;
      aList.forEach(doc => {
        if (doc.check == !this.isCheckAllowences) {
          doc.check = this.isCheckAllowences;
        }
      });
    },
    async getCheckAllowences() {
      this.selectedAllowences = [];
      await this.allowences.forEach(doc => {
        if (doc.check == true) {
          this.selectedAllowences.push(doc.id);
        }
      });
    },
    async getAllowences() {
      try {
        this.isLoading = true;
        const allowences = [];
        const response = await this.$axios
          .get("/Allowences")
          .then(response => {
            response.data.forEach(doc => {
              allowences.push({
                id: doc.id,
                shortCode: doc.shortCode,
                name: doc.name,
                monthlyPayrollId: doc.monthlyPayrollId,
                dailyPayrollId: doc.dailyPayrollId,
                dayTime: doc.dayTime,
                colorCode: doc.colorCode,
                r: doc.r,
                g: doc.g,
                b: doc.b,
                check: true
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.allowences = allowences;
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoading = false;
      }
    },
    checkAllVisitorGroups() {
      this.isCheckVG = !this.isCheckVG;
      let aList = this.visitorGroups;
      aList.forEach(doc => {
        if (doc.check == !this.isCheckVG) {
          doc.check = this.isCheckVG;
        }
      });
    },
    async getCheckVisitorGroups() {
      this.selectedVisitorGroups = [];
      await this.visitorGroups.forEach(doc => {
        if (doc.check == true) {
          this.selectedVisitorGroups.push(doc.id);
        }
      });
    },
    async getVisitorCardGroups() {
      try {
        const visitorGroups = [];
        const response = await this.$axios
          .get("/Visitors/GetVisitorsCardGroup")
          .then(response => {
            if (response.status == 200) {
              response.data.forEach(doc => {
                visitorGroups.push({
                  id: doc.id,
                  name: doc.name,
                  devices: doc.devices,
                  check: true
                });
              });
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.visitorGroups = visitorGroups;
      } catch (error) {
        console.error(error);
        alertify.error("Hata :" + error.message);
      }
    },
    getDefaultDate() {
      let toDay = new Date();
      var gun = (toDay.getDate() < 10 ? "0" : "") + toDay.getDate();
      var ay = (toDay.getMonth() < 9 ? "0" : "") + (toDay.getMonth() + 1);
      var yil = toDay.getFullYear();
      if (this.startDate == null) {
        this.startDate = yil + "-" + ay + "-" + gun + "T00:00";
      }
      if (this.endDate == null) {
        this.endDate = yil + "-" + ay + "-" + gun + "T23:59";
      }
    },
    setUserAuthorityFilter(filter) {
      filter.accessGroup
        ? (this.filters.accessGroup = filter.accessGroup)
        : (this.filters.accessGroup = []);
      filter.foodGroup
        ? (this.filters.foodGroup = filter.foodGroup)
        : (this.filters.foodGroup = []);
      filter.workGroupId
        ? (this.filters.workGroupId = filter.workGroupId)
        : (this.filters.workGroupId = []);
      filter.stateId
        ? (this.filters.stateId = filter.stateId)
        : (this.filters.stateId = []);
      filter.statuId
        ? (this.filters.statuId = filter.statuId)
        : (this.filters.statuId = []);
      this.filters.departments = filter.departments;
      this.filters.nameOrCardNumber = filter.nameOrCardNumber;
      this.filters.sicilOrTerminalNo = filter.sicilOrTerminalNo;
      this.filters.isActive = filter.isActive;
      this.filters.documentNoOrMail = filter.documentNoOrMail;
      this.filters.identityNo = filter.identityNo;
      this.filters.title = filter.title;
      this.filters.extraField1key = filter.extraField1key;
      this.filters.extraField1value = filter.extraField1value;
      this.filters.extraField2key = filter.extraField2key;
      this.filters.extraField2value = filter.extraField2value;
      this.filters.extraField3key = filter.extraField3key;
      this.filters.extraField3value = filter.extraField3value;
      this.filters.extraField4key = filter.extraField4key;
      this.filters.extraField4value = filter.extraField4value;
      this.filters.isVisitor = filter.isVisitor;
      this.filters.plateNo = filter.plateNo;
      //this.filters = filter;
      this.sortableDepartmentList.forEach(doc => {
        this.filters.departments.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.check = true;
          }
        });
      });
      this.workGroupList.forEach(doc => {
        this.filters.workGroupId.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.accessGroupList.forEach(doc => {
        this.filters.accessGroup.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.foodGroupList.forEach(doc => {
        this.filters.foodGroup.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.stateList.forEach(doc => {
        this.filters.stateId.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.statuList.forEach(doc => {
        this.filters.statuId.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
    },
    async getAuthControl() {
      if (this.authControl == 1) {
        alertify.warning(this.$ml.get("alerts.userIsNotAuthorizedToSeeData"));
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  async created() {
    await this.getAuthControl();
    await this.getDefaultDate();
    await this.getDepartments();
    await this.getAccessGroups();
    await this.getActiveReports();
    await this.getFoodGroups();
    await this.getStatus();
    await this.getStates();
    await this.getTitles();
    await this.getWorkGroups();
    await this.getExtraFields();
    await this.getReaders();
    await this.getVisitorCardGroups();
    await this.getAllowences();
    if (this.defaultFilters) {
      var filter = this.defaultFilters;
      this.setUserAuthorityFilter(filter);
      await this.getEmployees();
    } else {
      await this.getEmployees();
    }
  }
};
</script>

<style scoped>
.dep-baslik {
  font-weight: bold;
  background-color: #3c8dbc;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/pages/reports/Reports.vue